var ot = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Xt(h) {
  return h && h.__esModule && Object.prototype.hasOwnProperty.call(h, "default") ? h.default : h;
}
var zt = { exports: {} };
(function(h) {
  function E(x) {
    return x && x.__esModule ? x : {
      default: x
    };
  }
  h.exports = E, h.exports.__esModule = !0, h.exports.default = h.exports;
})(zt);
var te = zt.exports, qe = { exports: {} }, st;
function oe() {
  return st || (st = 1, function(h) {
    function E(x, q) {
      if (!(x instanceof q))
        throw new TypeError("Cannot call a class as a function");
    }
    h.exports = E, h.exports.__esModule = !0, h.exports.default = h.exports;
  }(qe)), qe.exports;
}
var me = { exports: {} }, Se = { exports: {} }, Ee = { exports: {} }, ut;
function le() {
  return ut || (ut = 1, function(h) {
    function E(x) {
      "@babel/helpers - typeof";
      return h.exports = E = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(q) {
        return typeof q;
      } : function(q) {
        return q && typeof Symbol == "function" && q.constructor === Symbol && q !== Symbol.prototype ? "symbol" : typeof q;
      }, h.exports.__esModule = !0, h.exports.default = h.exports, E(x);
    }
    h.exports = E, h.exports.__esModule = !0, h.exports.default = h.exports;
  }(Ee)), Ee.exports;
}
var Ae = { exports: {} }, at;
function Yt() {
  return at || (at = 1, function(h) {
    var E = le().default;
    function x(q, b) {
      if (E(q) != "object" || !q)
        return q;
      var g = q[Symbol.toPrimitive];
      if (g !== void 0) {
        var d = g.call(q, b || "default");
        if (E(d) != "object")
          return d;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (b === "string" ? String : Number)(q);
    }
    h.exports = x, h.exports.__esModule = !0, h.exports.default = h.exports;
  }(Ae)), Ae.exports;
}
var ct;
function Mt() {
  return ct || (ct = 1, function(h) {
    var E = le().default, x = Yt();
    function q(b) {
      var g = x(b, "string");
      return E(g) == "symbol" ? g : g + "";
    }
    h.exports = q, h.exports.__esModule = !0, h.exports.default = h.exports;
  }(Se)), Se.exports;
}
var lt;
function se() {
  return lt || (lt = 1, function(h) {
    var E = Mt();
    function x(b, g) {
      for (var d = 0; d < g.length; d++) {
        var f = g[d];
        f.enumerable = f.enumerable || !1, f.configurable = !0, "value" in f && (f.writable = !0), Object.defineProperty(b, E(f.key), f);
      }
    }
    function q(b, g, d) {
      return g && x(b.prototype, g), d && x(b, d), Object.defineProperty(b, "prototype", {
        writable: !1
      }), b;
    }
    h.exports = q, h.exports.__esModule = !0, h.exports.default = h.exports;
  }(me)), me.exports;
}
function Zt(h) {
  throw new Error('Could not dynamically require "' + h + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var Re = { exports: {} }, ft;
function $t() {
  return ft || (ft = 1, function(h) {
    (function() {
      Object.assign || Object.defineProperty(Object, "assign", { enumerable: !1, configurable: !0, writable: !0, value: function(q) {
        if (q == null)
          throw new TypeError("Cannot convert first argument to object");
        for (var b = Object(q), g = 1; g < arguments.length; g++) {
          var d = arguments[g];
          if (d != null) {
            d = Object(d);
            for (var f = Object.keys(Object(d)), a = 0, w = f.length; w > a; a++) {
              var m = f[a], p = Object.getOwnPropertyDescriptor(d, m);
              p !== void 0 && p.enumerable && (b[m] = d[m]);
            }
          }
        }
        return b;
      } });
      function E(q) {
        let b;
        try {
          b = window[q];
          const g = "__storage_test__";
          return b.setItem(g, g), b.removeItem(g), !0;
        } catch (g) {
          return DOMException && g instanceof DOMException && (g.name === "QuotaExceededError" || g.name === "QUOTA_EXCEEDED_ERR" || g.name === "NS_ERROR_DOM_QUOTA_REACHED" || g.toString().indexOf("QUOTA_EXCEEDED_ERR") !== -1 || g.toString().indexOf("QuotaExceededError") !== -1) && b && b.length !== 0;
        }
      }
      var x = function(q) {
        var b = {
          user_agent: null,
          persist: !0,
          cookie_name_client_id: "ConstructorioID_client_id",
          cookie_name_session_id: "ConstructorioID_session_id",
          cookie_name_session_data: "ConstructorioID_session",
          cookie_domain: null,
          cookie_secure: null,
          // null, true
          cookie_samesite: null,
          // null, Lax, Strict
          cookie_days_to_live: 365,
          encode_cookie_values: !1,
          local_name_client_id: "_constructorio_search_client_id",
          local_name_session_id: "_constructorio_search_session_id",
          local_name_session_data: "_constructorio_search_session",
          on_node: typeof window > "u",
          session_is_new: null,
          new_to_beacon: null,
          client_id_storage_location: "cookie",
          session_id_storage_location: "local"
        };
        if (Object.assign(this, b, q), !this.client_id)
          if (!this.on_node && this.persist) {
            var g;
            this.client_id_storage_location === "cookie" && (g = this.get_cookie(this.cookie_name_client_id), g && (this.delete_cookie(this.cookie_name_client_id), this.set_cookie(this.cookie_name_client_id, g))), this.client_id_storage_location === "local" && (g = this.get_local_object(this.local_name_client_id)), this.client_id = g || this.generate_client_id();
          } else
            this.client_id = this.generate_client_id();
        this.session_id || (!this.on_node && this.persist ? this.session_id = this.generate_session_id() : this.session_id = 1), this.on_node || (this.user_agent = this.user_agent || window && window.navigator && window.navigator.userAgent);
      };
      x.prototype.set_cookie = function(q, b) {
        if (!this.on_node && this.persist) {
          var g = new Date(Date.now() + this.cookie_days_to_live * 24 * 60 * 60 * 1e3), d = b;
          this.encode_cookie_values && (d = encodeURIComponent(b));
          var f = q + "=" + d + "; expires=" + g.toUTCString() + "; path=/";
          return this.cookie_domain && (f += "; domain=" + this.cookie_domain), this.cookie_secure && (f += "; secure"), this.cookie_samesite && (f += "; samesite=" + this.cookie_samesite), document.cookie = f, f;
        }
        return null;
      }, x.prototype.get_cookie = function(q) {
        for (var b = q + "=", g = document.cookie.split(";"), d = 0; d < g.length; d++) {
          var f = g[d];
          try {
            for (var a = decodeURIComponent(f); a.charAt(0) === " "; )
              a = a.substring(1);
            if (a.indexOf(b) === 0)
              return a.substring(b.length, a.length);
          } catch {
          }
        }
      }, x.prototype.delete_cookie = function(q) {
        document.cookie = q + "=;expires=Thu, 01 Jan 1970 00:00:01 GMT;";
      }, x.prototype.generate_client_id = function() {
        var q;
        if (!this.on_node) {
          var b = this.get_cookie(this.cookie_name_client_id), g = this.get_local_object(this.local_name_client_id);
          this.client_id_storage_location === "cookie" && g && (q = g, this.set_cookie(this.cookie_name_client_id, q), this.delete_local_object(this.local_name_client_id)), this.client_id_storage_location === "local" && b && (q = b, this.set_local_object(this.local_name_client_id, q), this.delete_cookie(this.cookie_name_client_id));
        }
        return q || (q = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(d) {
          var f = Math.random() * 16 | 0, a = d === "x" ? f : f & 3 | 8;
          return a.toString(16);
        }), this.client_id_storage_location === "cookie" && this.set_cookie(this.cookie_name_client_id, q), this.client_id_storage_location === "local" && this.set_local_object(this.local_name_client_id, q)), q;
      }, x.prototype.get_local_object = function(q) {
        var b, g = E("localStorage") && window && window.localStorage;
        if (g && typeof q == "string")
          try {
            b = JSON.parse(g.getItem(q));
          } catch {
            b = g.getItem(q);
          }
        return b;
      }, x.prototype.set_local_object = function(q, b) {
        var g = E("localStorage") && window && window.localStorage;
        if (g && typeof q == "string") {
          if (typeof b == "object")
            try {
              g.setItem(q, JSON.stringify(b));
            } catch {
            }
          if (typeof b == "string" || typeof b == "number")
            try {
              g.setItem(q, b);
            } catch {
            }
        }
      }, x.prototype.delete_local_object = function(q) {
        var b = E("localStorage") && window && window.localStorage;
        if (b && typeof q == "string")
          try {
            b.removeItem(q);
          } catch {
          }
      }, x.prototype.generate_session_id = function() {
        var q = this.get_cookie(this.cookie_name_session_data), b = this.get_local_object(this.local_name_session_data), g = Date.now(), d = 1e3 * 60 * 30, f;
        if (this.session_id_storage_location === "local" && (f = this.get_local_object(this.local_name_session_data), !f && q && (f = q, this.delete_cookie(this.cookie_name_session_data))), this.session_id_storage_location === "cookie") {
          f = this.get_cookie(this.cookie_name_session_data);
          try {
            f = JSON.parse(f);
          } catch {
          }
          !f && b && (f = b, this.delete_local_object(this.local_name_session_data));
        }
        var a = 1, w = 1;
        f && typeof f == "object" && (w = parseInt(f.sessionId, 10) || 1, f.lastTime > g - d ? a = w : a = w + 1), this.session_id = a, this.session_is_new = !(f && w === a), f && f.newToBeacon && (this.new_to_beacon = !0);
        const m = {
          sessionId: a,
          lastTime: g
        };
        return this.session_is_new && (m.newToBeacon = !0), this.session_id_storage_location === "local" && (this.set_local_object(this.local_name_session_id, a), this.set_local_object(this.local_name_session_data, m)), this.session_id_storage_location === "cookie" && (this.cookie_domain && (this.delete_cookie(this.cookie_name_session_id), this.delete_cookie(this.cookie_name_session_data)), this.set_cookie(this.cookie_name_session_id, a), this.set_cookie(this.cookie_name_session_data, JSON.stringify(m))), a;
      }, typeof Zt < "u" && (h.exports = x);
    })();
  }(Re)), Re.exports;
}
var Ce = {};
/*! crc32.js (C) 2014-present SheetJS -- http://sheetjs.com */
var vt;
function er() {
  return vt || (vt = 1, function(h) {
    (function(E) {
      E(typeof DO_NOT_EXPORT_CRC > "u" ? h : {});
    })(function(E) {
      E.version = "1.2.2";
      function x() {
        for (var r = 0, u = new Array(256), o = 0; o != 256; ++o)
          r = o, r = r & 1 ? -306674912 ^ r >>> 1 : r >>> 1, r = r & 1 ? -306674912 ^ r >>> 1 : r >>> 1, r = r & 1 ? -306674912 ^ r >>> 1 : r >>> 1, r = r & 1 ? -306674912 ^ r >>> 1 : r >>> 1, r = r & 1 ? -306674912 ^ r >>> 1 : r >>> 1, r = r & 1 ? -306674912 ^ r >>> 1 : r >>> 1, r = r & 1 ? -306674912 ^ r >>> 1 : r >>> 1, r = r & 1 ? -306674912 ^ r >>> 1 : r >>> 1, u[o] = r;
        return typeof Int32Array < "u" ? new Int32Array(u) : u;
      }
      var q = x();
      function b(r) {
        var u = 0, o = 0, y = 0, k = typeof Int32Array < "u" ? new Int32Array(4096) : new Array(4096);
        for (y = 0; y != 256; ++y)
          k[y] = r[y];
        for (y = 0; y != 256; ++y)
          for (o = r[y], u = 256 + y; u < 4096; u += 256)
            o = k[u] = o >>> 8 ^ r[o & 255];
        var R = [];
        for (y = 1; y != 16; ++y)
          R[y - 1] = typeof Int32Array < "u" ? k.subarray(y * 256, y * 256 + 256) : k.slice(y * 256, y * 256 + 256);
        return R;
      }
      var g = b(q), d = g[0], f = g[1], a = g[2], w = g[3], m = g[4], p = g[5], A = g[6], C = g[7], v = g[8], l = g[9], e = g[10], t = g[11], _ = g[12], n = g[13], c = g[14];
      function S(r, u) {
        for (var o = u ^ -1, y = 0, k = r.length; y < k; )
          o = o >>> 8 ^ q[(o ^ r.charCodeAt(y++)) & 255];
        return ~o;
      }
      function s(r, u) {
        for (var o = u ^ -1, y = r.length - 15, k = 0; k < y; )
          o = c[r[k++] ^ o & 255] ^ n[r[k++] ^ o >> 8 & 255] ^ _[r[k++] ^ o >> 16 & 255] ^ t[r[k++] ^ o >>> 24] ^ e[r[k++]] ^ l[r[k++]] ^ v[r[k++]] ^ C[r[k++]] ^ A[r[k++]] ^ p[r[k++]] ^ m[r[k++]] ^ w[r[k++]] ^ a[r[k++]] ^ f[r[k++]] ^ d[r[k++]] ^ q[r[k++]];
        for (y += 15; k < y; )
          o = o >>> 8 ^ q[(o ^ r[k++]) & 255];
        return ~o;
      }
      function i(r, u) {
        for (var o = u ^ -1, y = 0, k = r.length, R = 0, O = 0; y < k; )
          R = r.charCodeAt(y++), R < 128 ? o = o >>> 8 ^ q[(o ^ R) & 255] : R < 2048 ? (o = o >>> 8 ^ q[(o ^ (192 | R >> 6 & 31)) & 255], o = o >>> 8 ^ q[(o ^ (128 | R & 63)) & 255]) : R >= 55296 && R < 57344 ? (R = (R & 1023) + 64, O = r.charCodeAt(y++) & 1023, o = o >>> 8 ^ q[(o ^ (240 | R >> 8 & 7)) & 255], o = o >>> 8 ^ q[(o ^ (128 | R >> 2 & 63)) & 255], o = o >>> 8 ^ q[(o ^ (128 | O >> 6 & 15 | (R & 3) << 4)) & 255], o = o >>> 8 ^ q[(o ^ (128 | O & 63)) & 255]) : (o = o >>> 8 ^ q[(o ^ (224 | R >> 12 & 15)) & 255], o = o >>> 8 ^ q[(o ^ (128 | R >> 6 & 63)) & 255], o = o >>> 8 ^ q[(o ^ (128 | R & 63)) & 255]);
        return ~o;
      }
      E.table = q, E.bstr = S, E.buf = s, E.str = i;
    });
  }(Ce)), Ce;
}
var xe, dt;
function it() {
  if (dt)
    return xe;
  dt = 1;
  function h(b) {
    var g;
    try {
      g = window[b];
      var d = "__storage_test__";
      return g.setItem(d, d), g.removeItem(d), !0;
    } catch (f) {
      return typeof DOMException < "u" && f instanceof DOMException && (f.name === "QuotaExceededError" || f.name === "QUOTA_EXCEEDED_ERR" || f.name === "NS_ERROR_DOM_QUOTA_REACHED" || f.toString().indexOf("QUOTA_EXCEEDED_ERR") !== -1 || f.toString().indexOf("QuotaExceededError") !== -1) && g && g.length !== 0;
    }
  }
  var E = {
    overflow: {},
    get: function(g) {
      var d = this.overflow[g];
      if (d)
        return d;
      if (!h("sessionStorage"))
        return null;
      var f = sessionStorage.getItem(g);
      if (f)
        try {
          return JSON.parse(f);
        } catch {
          return f;
        }
      return null;
    },
    set: function(g, d) {
      try {
        sessionStorage.setItem(g, JSON.stringify(d));
      } catch {
        this.overflow[g] = d;
      }
    },
    remove: function(g) {
      var d;
      (d = this.overflow) !== null && d !== void 0 && d[g] && delete this.overflow[g], h("sessionStorage") && sessionStorage.removeItem(g);
    },
    key: function(g) {
      var d, f;
      if (!h("sessionStorage")) {
        var a;
        return (a = Object.keys(this.overflow)) === null || a === void 0 ? void 0 : a[g];
      }
      var w = (d = sessionStorage) === null || d === void 0 ? void 0 : d.key(g), m = ((f = sessionStorage) === null || f === void 0 ? void 0 : f.length) || 0;
      if (g >= m) {
        var p, A = g - m;
        return (p = Object.keys(this.overflow)) === null || p === void 0 ? void 0 : p[A];
      }
      return w;
    },
    length: function() {
      var g = Object.keys(this.overflow).length;
      return h("sessionStorage") ? sessionStorage.length + g : g;
    },
    clear: function() {
      this.overflow = {}, h("sessionStorage") && sessionStorage.clear();
    }
  }, x = {
    overflow: {},
    get: function(g) {
      var d = this.overflow[g];
      if (d)
        return d;
      if (!h("localStorage"))
        return null;
      var f = localStorage.getItem(g);
      if (f)
        try {
          return JSON.parse(f);
        } catch {
          return f;
        }
      return null;
    },
    set: function(g, d) {
      try {
        localStorage.setItem(g, JSON.stringify(d));
      } catch {
        this.overflow[g] = d;
      }
    },
    remove: function(g) {
      var d;
      (d = this.overflow) !== null && d !== void 0 && d[g] && delete this.overflow[g], h("localStorage") && localStorage.removeItem(g);
    },
    key: function(g) {
      var d, f;
      if (!h("localStorage")) {
        var a;
        return (a = Object.keys(this.overflow)) === null || a === void 0 ? void 0 : a[g];
      }
      var w = (d = localStorage) === null || d === void 0 ? void 0 : d.key(g), m = ((f = localStorage) === null || f === void 0 ? void 0 : f.length) || 0;
      if (g >= m) {
        var p, A = g - m;
        return (p = Object.keys(this.overflow)) === null || p === void 0 ? void 0 : p[A];
      }
      return w;
    },
    length: function() {
      var g = Object.keys(this.overflow).length;
      return h("localStorage") ? localStorage.length + g : g;
    },
    clear: function() {
      this.overflow = {}, h("localStorage") && localStorage.clear();
    }
  }, q = {
    local: x,
    session: E,
    canUseStorage: h
  };
  return xe = q, xe;
}
var Oe, ht;
function ne() {
  if (ht)
    return Oe;
  ht = 1;
  var h = te, E = h(le()), x = er(), q = it(), b = "_constructorio_purchase_order_ids", g = [
    {
      pattern: /[\w\-+\\.]+@([\w-]+\.)+[\w-]{2,4}/,
      replaceWith: "<email_omitted>"
    },
    {
      pattern: /^(?:\+\d{11,12}|\+\d{1,3}\s\d{3}\s\d{3}\s\d{3,4}|\(\d{3}\)\d{7}|\(\d{3}\)\s\d{3}\s\d{4}|\(\d{3}\)\d{3}-\d{4}|\(\d{3}\)\s\d{3}-\d{4})$/,
      replaceWith: "<phone_omitted>"
    },
    {
      pattern: /^(?:4[0-9]{15}|(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|6(?:011|5[0-9]{2})[0-9]{12}|(?:2131|1800|35\d{3})\d{11})$/,
      // Visa, Mastercard, Amex, Discover, JCB and Diners Club, regex source: https://www.regular-expressions.info/creditcard.html
      replaceWith: "<credit_omitted>"
    }
    // Add more PII REGEX
  ], d = 2e3, f = {
    trimNonBreakingSpaces: function(w) {
      return w.replace(/\s/g, " ").trim();
    },
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURIComponent#encoding_for_rfc3986
    encodeURIComponentRFC3986: function(w) {
      return encodeURIComponent(w).replace(/[!'()*]/g, function(m) {
        return "%".concat(m.charCodeAt(0).toString(16).toUpperCase());
      });
    },
    cleanParams: function(w) {
      var m = {};
      return Object.keys(w).forEach(function(p) {
        var A = w[p];
        typeof A == "string" ? m[p] = f.trimNonBreakingSpaces(A) : m[p] = A;
      }), m;
    },
    trimUrl: function(w) {
      var m = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : d, p = w.toString();
      if (p.length <= m)
        return p;
      var A = new URL(w.toString()), C = A.searchParams, v = Array.from(C.entries());
      if (v.length === 0)
        return f.truncateString(p, m);
      v.sort(function(e, t) {
        var _ = e[0].length + e[1].length, n = t[0].length + t[1].length;
        return n - _;
      });
      for (var l = 0; l < v.length && !(p.length <= m); l += 1)
        C.delete(v[l][0]), p = A.toString();
      return p.length > m ? f.truncateString(p, m) : p;
    },
    cleanAndValidateUrl: function(w) {
      var m = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : void 0, p = null;
      try {
        var A;
        if ((A = w) !== null && A !== void 0 && A.startsWith("android-app")) {
          var C;
          w = (C = w) === null || C === void 0 ? void 0 : C.replace("android-app", "https");
        }
        var v = new URL(w, m), l = new URL(f.trimUrl(v));
        p = l.toString();
      } catch {
      }
      return p;
    },
    throwHttpErrorFromResponse: function(w, m) {
      return m.json().then(function(p) {
        throw w.message = p.message, w.status = m.status, w.statusText = m.statusText, w.url = m.url, w.headers = m.headers, w;
      });
    },
    canUseDOM: function() {
      return !!(typeof window < "u" && window.document && window.document.createElement);
    },
    addEventListener: function(w, m, p) {
      f.canUseDOM() && window.addEventListener(w, m, p);
    },
    removeEventListener: function(w, m, p) {
      f.canUseDOM() && window.removeEventListener(w, m, p);
    },
    getNavigator: function() {
      return f.canUseDOM() ? window.navigator : {
        userAgent: "",
        webdriver: !1
      };
    },
    isNil: function(w) {
      return w == null;
    },
    getWindowLocation: function() {
      return f.canUseDOM() ? window.location : {};
    },
    getDocumentReferrer: function() {
      var w = null;
      try {
        f.canUseDOM() && (w = f.cleanAndValidateUrl(document.referrer));
      } catch {
      }
      return w;
    },
    getCanonicalUrl: function() {
      var w = null;
      try {
        if (f.canUseDOM()) {
          var m, p = (m = document) === null || m === void 0 ? void 0 : m.querySelector('link[rel="canonical"]'), A = p == null ? void 0 : p.getAttribute("href");
          A && (w = f.cleanAndValidateUrl(A, document.location.href));
        }
      } catch {
      }
      return w;
    },
    dispatchEvent: function(w) {
      f.canUseDOM() && window.dispatchEvent(w);
    },
    createCustomEvent: function(w, m) {
      if (f.canUseDOM())
        try {
          return new window.CustomEvent(w, {
            detail: m
          });
        } catch {
          var p = document.createEvent("CustomEvent");
          return p.initCustomEvent(w, !1, !1, m), p;
        }
      return null;
    },
    hasOrderIdRecord: function(w) {
      var m = w.orderId, p = w.apiKey, A = m;
      p && (A = "".concat(p, "-").concat(m));
      var C = x.str(A.toString()), v = q.local.get(b);
      return typeof v == "string" && (v = JSON.parse(v)), v && v.includes(C) ? !0 : null;
    },
    addOrderIdRecord: function(w) {
      var m = w.orderId, p = w.apiKey, A = m;
      p && (A = "".concat(p, "-").concat(m));
      var C = x.str(A.toString()), v = q.local.get(b);
      if (typeof v == "string" && (v = JSON.parse(v)), v) {
        if (v.includes(C))
          return;
        v.length >= 10 && (v = v.slice(-9)), v.push(C);
      } else
        v = [C];
      q.local.set(b, v);
    },
    // Abort network request based on supplied timeout interval (in milliseconds)
    // - method call parameter takes precedence over global options parameter
    applyNetworkTimeout: function() {
      var w = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, m = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, p = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, A = w && w.networkParameters && w.networkParameters.timeout, C = m && m.timeout, v = C || A;
      typeof v == "number" && p && setTimeout(function() {
        return p.abort();
      }, v);
    },
    stringify: function(w, m, p) {
      if (!w)
        return "";
      var A = [];
      return Object.keys(w).forEach(function(C) {
        var v = w[C], l = f.encodeURIComponentRFC3986(C), e;
        if (v != null) {
          var t = m ? "".concat(m, "%5B").concat(l, "%5D") : l;
          Array.isArray(v) ? e = f.stringify(v, t, "array") : (0, E.default)(v) === "object" ? e = f.stringify(v, t, "object") : p === "object" ? e = "".concat(t, "=").concat(f.encodeURIComponentRFC3986(v)) : e = "".concat(m || l, "=").concat(f.encodeURIComponentRFC3986(v)), A.push(e);
        }
      }), A.join("&");
    },
    toSnakeCase: function(w) {
      return w.replace(/[A-Z]/g, function(m) {
        return "_".concat(m.toLowerCase());
      });
    },
    toSnakeCaseKeys: function(w) {
      var m = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, p = {};
      return Object.keys(w).forEach(function(A) {
        var C = f.toSnakeCase(A);
        p[C] = m && (0, E.default)(w[A]) === "object" && !Array.isArray(w[A]) ? f.toSnakeCaseKeys(w[A], m) : w[A];
      }), p;
    },
    containsPii: function(w, m) {
      var p = w.toLowerCase();
      return m.test(p);
    },
    obfuscatePiiRequest: function(w) {
      var m = w;
      try {
        var p, A, C = new URL(w), v = C == null || (p = C.pathname) === null || p === void 0 ? void 0 : p.split("/"), l = C == null || (A = C.search) === null || A === void 0 || (A = A.split("&")) === null || A === void 0 ? void 0 : A.map(function(e) {
          var t;
          return (t = e.split("=")) === null || t === void 0 ? void 0 : t[1];
        });
        g.forEach(function(e) {
          var t = e.pattern, _ = e.replaceWith;
          v.forEach(function(n) {
            var c = decodeURIComponent(n);
            f.containsPii(c, t) && (m = m.replaceAll(n, _));
          }), l.forEach(function(n) {
            var c = decodeURIComponent(n);
            f.containsPii(c, t) && (m = m.replaceAll(c, _));
          });
        });
      } catch {
      }
      return m;
    },
    convertResponseToJson: function(w) {
      return w.ok ? w.json().catch(function() {
        return w.text().then(function(m) {
          throw new Error("Server responded with an invalid JSON object. Response code: ".concat(w.code, ", Response: ").concat(m));
        });
      }) : f.throwHttpErrorFromResponse(new Error(), w);
    },
    addHTTPSToString: function(w) {
      if (typeof w != "string")
        return null;
      var m = w.startsWith("https://"), p = w.startsWith("http://");
      if (!m && p)
        return w.replace("http", "https");
      if (!p && !m) {
        var A = "https://".concat(w);
        return A;
      }
      return w;
    },
    truncateString: function(w, m) {
      return w.slice(0, m);
    },
    // Filter testCells to only include entries with non-empty string values
    toValidTestCells: function(w) {
      if (!w || (0, E.default)(w) !== "object" || Array.isArray(w))
        return {};
      var m = {};
      return Object.keys(w).forEach(function(p) {
        typeof w[p] == "string" && w[p].trim() !== "" && (m[p] = w[p]);
      }), m;
    },
    getBehaviorUrl: function(w) {
      var m = new URL(w);
      return m.hostname.startsWith("behavior") || (m.hostname = "behavior.".concat(m.hostname)), m;
    }
  };
  return Oe = f, Oe;
}
var Te, gt;
function ve() {
  if (gt)
    return Te;
  gt = 1;
  var h = te, E = h(oe()), x = h(se()), q = ne(), b = /* @__PURE__ */ function() {
    function g(d) {
      var f = this;
      (0, E.default)(this, g), this.events = [], this.enabled = !(d && d.enabled === !1), this.waitForBeacon = !(d && d.waitForBeacon === !1), this.active = this.enabled, this.waitForBeacon && (this.active = !1, q.canUseDOM() && (window.ConstructorioAutocomplete || window.ConstructorioBeacon || window.ConstructorioTracker) && this.enabled && (this.active = !0, this.dispatchEvents()), q.addEventListener("cio.beacon.loaded", function() {
        f.enabled && (f.active = !0, f.dispatchEvents());
      }));
    }
    return (0, x.default)(g, [{
      key: "queue",
      value: function(f, a) {
        this.events.push({
          name: f,
          data: a
        }), this.active && this.dispatchEvents();
      }
      // Dispatch all custom events within queue on `window` of supplied name with data
    }, {
      key: "dispatchEvents",
      value: function() {
        for (; this.events.length; ) {
          var f = this.events.shift(), a = f.name, w = f.data, m = "cio.client.".concat(a);
          q.dispatchEvent(q.createCustomEvent(m, w));
        }
      }
    }]);
  }();
  return Te = b, Te;
}
var Ue, _t;
function tr() {
  if (_t)
    return Ue;
  _t = 1;
  var h = te, E = h(oe()), x = h(se()), q = ve(), b = ne();
  function g(f, a, w) {
    var m = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1, p = w.apiKey, A = w.version, C = w.serviceUrl, v = w.sessionId, l = w.clientId, e = w.userId, t = w.segments, _ = w.testCells, n = {
      c: A
    };
    if (n.key = p, n.i = l, n.s = v, !f || typeof f != "string")
      throw new Error("query is a required parameter of type string");
    if (_ && Object.keys(_).forEach(function(I) {
      n["ef-".concat(I)] = _[I];
    }), t && t.length && (n.us = t), e && (n.ui = String(e)), a) {
      var c = a.offset, S = a.page, s = a.resultsPerPage, i = a.filters, r = a.sortBy, u = a.sortOrder, o = a.section, y = a.fmtOptions, k = a.hiddenFields, R = a.hiddenFacets, O = a.variationsMap, N = a.qsParam, T = a.preFilterExpression, U = a.filterMatchTypes;
      b.isNil(c) || (n.offset = c), b.isNil(S) || (n.page = S), b.isNil(s) || (n.num_results_per_page = s), i && (n.filters = i), U && (n.filter_match_types = U), r && (n.sort_by = r), u && (n.sort_order = u), o && (n.section = o), y && (n.fmt_options = y), k && (n.fmt_options ? n.fmt_options.hidden_fields = k : n.fmt_options = {
        hidden_fields: k
      }), R && (n.fmt_options ? n.fmt_options.hidden_facets = R : n.fmt_options = {
        hidden_facets: R
      }), O && (n.variations_map = JSON.stringify(O)), T && (n.pre_filter_expression = JSON.stringify(T)), N && (n.qs = JSON.stringify(N));
    }
    n._dt = Date.now(), n = b.cleanParams(n);
    var D = b.stringify(n), L = m ? "search/natural_language" : "search";
    return "".concat(C, "/").concat(L, "/").concat(b.encodeURIComponentRFC3986(b.trimNonBreakingSpaces(f)), "?").concat(D);
  }
  var d = /* @__PURE__ */ function() {
    function f(a) {
      (0, E.default)(this, f), this.options = a || {}, this.eventDispatcher = new q(a.eventDispatcher);
    }
    return (0, x.default)(f, [{
      key: "getSearchResults",
      value: function(w, m) {
        var p = this, A = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, C, v = this.options.fetch, l;
        if (typeof AbortController == "function") {
          var e = new AbortController();
          l = e && e.signal, b.applyNetworkTimeout(this.options, A, e);
        }
        try {
          C = g(w, m, this.options);
        } catch (t) {
          return Promise.reject(t);
        }
        return v(C, {
          signal: l
        }).then(b.convertResponseToJson).then(function(t) {
          if (t.response && t.response.results)
            return t.result_id && t.response.results.forEach(function(_) {
              _.result_id = t.result_id;
            }), p.eventDispatcher.queue("search.getSearchResults.completed", t), t;
          if (t.response && t.response.redirect)
            return p.eventDispatcher.queue("search.getSearchResults.completed", t), t;
          throw new Error("getSearchResults response data is malformed");
        });
      }
      /**
       * Retrieve voice search results from API
       *
       * @function getVoiceSearchResults
       * @description Retrieve voice search results from Constructor.io API
       * @param {string} query - Term to use to perform a voice search
       * @param {object} [parameters] - Additional parameters to refine result set
       * @param {number} [parameters.page] - The page number of the results (Can't be used together with offset)
       * @param {number} [parameters.offset] - The number of results to skip from the beginning (Can't be used together with page)
       * @param {number} [parameters.resultsPerPage] - The number of results per page to return
       * @param {string} [parameters.section='Products'] - The section name for results
       * @param {object} [parameters.fmtOptions] - The format options used to refine result groups. Please refer to https://docs.constructor.com/reference/v1-search-get-natural-language-search-results#query-params for details
       * @param {object} [parameters.preFilterExpression] - Faceting expression to scope search results. Please refer to https://docs.constructor.com/reference/configuration-collections
       * @param {object} [parameters.variationsMap] - The variations map object to aggregate variations. Please refer to https://docs.constructor.com/reference/shared-variations-mapping for details
       * @param {string[]} [parameters.hiddenFields] - Hidden metadata fields to return
       * @param {string[]} [parameters.hiddenFacets] - Hidden facets to return
       * @param {object} [parameters.qsParam] - Parameters listed above can be serialized into a JSON object and parsed through this parameter. Please refer to https://docs.constructor.com/reference/v1-search-get-natural-language-search-results#query-params
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {Promise}
       * @see https://docs.constructor.com/docs/products-search-learn-about-search
       * @example
       * constructorio.search.getVoiceSearchResults('show me lipstick');
       */
    }, {
      key: "getVoiceSearchResults",
      value: function(w, m) {
        var p = this, A = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, C, v = this.options.fetch, l;
        if (typeof AbortController == "function") {
          var e = new AbortController();
          l = e && e.signal, b.applyNetworkTimeout(this.options, A, e);
        }
        try {
          var t = !0;
          C = g(w, m, this.options, t);
        } catch (_) {
          return Promise.reject(_);
        }
        return v(C, {
          signal: l
        }).then(b.convertResponseToJson).then(function(_) {
          if (_.response && _.response.results)
            return _.result_id && _.response.results.forEach(function(n) {
              n.result_id = _.result_id;
            }), p.eventDispatcher.queue("search.getVoiceSearchResults.completed", _), _;
          if (_.response && _.response.redirect)
            return p.eventDispatcher.queue("search.getVoiceSearchResults.completed", _), _;
          throw new Error("getVoiceSearchResults response data is malformed");
        });
      }
    }]);
  }();
  return Ue = d, Ue;
}
var Ie = { exports: {} }, pt;
function ke() {
  return pt || (pt = 1, function(h) {
    var E = Mt();
    function x(q, b, g) {
      return (b = E(b)) in q ? Object.defineProperty(q, b, {
        value: g,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : q[b] = g, q;
    }
    h.exports = x, h.exports.__esModule = !0, h.exports.default = h.exports;
  }(Ie)), Ie.exports;
}
var Ne, yt;
function rr() {
  if (yt)
    return Ne;
  yt = 1;
  var h = te, E = h(oe()), x = h(se()), q = h(ke());
  function b(v, l) {
    var e = Object.keys(v);
    if (Object.getOwnPropertySymbols) {
      var t = Object.getOwnPropertySymbols(v);
      l && (t = t.filter(function(_) {
        return Object.getOwnPropertyDescriptor(v, _).enumerable;
      })), e.push.apply(e, t);
    }
    return e;
  }
  function g(v) {
    for (var l = 1; l < arguments.length; l++) {
      var e = arguments[l] != null ? arguments[l] : {};
      l % 2 ? b(Object(e), !0).forEach(function(t) {
        (0, q.default)(v, t, e[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(v, Object.getOwnPropertyDescriptors(e)) : b(Object(e)).forEach(function(t) {
        Object.defineProperty(v, t, Object.getOwnPropertyDescriptor(e, t));
      });
    }
    return v;
  }
  var d = ve(), f = ne();
  function a(v, l) {
    var e = l.apiKey, t = l.version, _ = l.sessionId, n = l.clientId, c = l.userId, S = l.segments, s = l.testCells, i = {
      c: t
    };
    if (i.key = e, i.i = n, i.s = _, s && Object.keys(s).forEach(function(P) {
      i["ef-".concat(P)] = s[P];
    }), S && S.length && (i.us = S), c && (i.ui = String(c)), v) {
      var r = v.page, u = v.offset, o = v.resultsPerPage, y = v.filters, k = v.sortBy, R = v.sortOrder, O = v.section, N = v.fmtOptions, T = v.hiddenFields, U = v.hiddenFacets, D = v.variationsMap, L = v.qsParam, I = v.preFilterExpression, B = v.filterMatchTypes;
      f.isNil(r) || (i.page = r), f.isNil(u) || (i.offset = u), f.isNil(o) || (i.num_results_per_page = o), y && (i.filters = y), B && (i.filter_match_types = B), k && (i.sort_by = k), R && (i.sort_order = R), O && (i.section = O), N && (i.fmt_options = N), T && (i.fmt_options ? i.fmt_options.hidden_fields = T : i.fmt_options = {
        hidden_fields: T
      }), U && (i.fmt_options ? i.fmt_options.hidden_facets = U : i.fmt_options = {
        hidden_facets: U
      }), D && (i.variations_map = JSON.stringify(D)), I && (i.pre_filter_expression = JSON.stringify(I)), L && (i.qs = JSON.stringify(L));
    }
    return i._dt = Date.now(), i = f.cleanParams(i), i;
  }
  function w(v, l, e, t) {
    var _ = t.serviceUrl;
    if (!v || typeof v != "string")
      throw new Error("filterName is a required parameter of type string");
    if (!l || typeof l != "string")
      throw new Error("filterValue is a required parameter of type string");
    var n = a(e, t), c = f.stringify(n);
    return "".concat(_, "/browse/").concat(f.encodeURIComponentRFC3986(f.trimNonBreakingSpaces(v)), "/").concat(f.encodeURIComponentRFC3986(f.trimNonBreakingSpaces(l)), "?").concat(c);
  }
  function m(v, l, e) {
    var t = e.serviceUrl;
    if (!v || !Array.isArray(v) || !v.length)
      throw new Error("ids is a required parameter of type array");
    var _ = g(g({}, a(l, e)), {}, {
      ids: v
    }), n = f.stringify(_);
    return "".concat(t, "/browse/items?").concat(n);
  }
  function p(v, l) {
    var e = l.serviceUrl, t = g({}, a(v, l));
    delete t._dt;
    var _ = f.stringify(t);
    return "".concat(e, "/browse/facets?").concat(_);
  }
  function A(v, l, e) {
    var t = e.serviceUrl;
    if (!v || typeof v != "string")
      throw new Error("facetName is a required parameter of type string");
    var _ = g({}, a(l, e));
    _.facet_name = v, delete _._dt;
    var n = f.stringify(_);
    return "".concat(t, "/browse/facet_options?").concat(n);
  }
  var C = /* @__PURE__ */ function() {
    function v(l) {
      (0, E.default)(this, v), this.options = l || {}, this.eventDispatcher = new d(l.eventDispatcher);
    }
    return (0, x.default)(v, [{
      key: "getBrowseResults",
      value: function(e, t, _) {
        var n = this, c = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, S, s = this.options.fetch, i;
        if (typeof AbortController == "function") {
          var r = new AbortController();
          i = r && r.signal, f.applyNetworkTimeout(this.options, c, r);
        }
        try {
          S = w(e, t, _, this.options);
        } catch (u) {
          return Promise.reject(u);
        }
        return s(S, {
          signal: i
        }).then(f.convertResponseToJson).then(function(u) {
          if (u.response && u.response.results)
            return u.result_id && u.response.results.forEach(function(o) {
              o.result_id = u.result_id;
            }), n.eventDispatcher.queue("browse.getBrowseResults.completed", u), u;
          throw new Error("getBrowseResults response data is malformed");
        });
      }
      /**
       * Retrieve browse results from API using item id's
       *
       * @function getBrowseResultsForItemIds
       * @param {string[]} itemIds - Item id's of results to fetch
       * @param {object} [parameters] - Additional parameters to refine result set
       * @param {number} [parameters.page] - The page number of the results (Can't be used together with offset)
       * @param {number} [parameters.offset] - The number of results to skip from the beginning (Can't be used together with page)
       * @param {number} [parameters.resultsPerPage] - The number of results per page to return
       * @param {object} [parameters.filters] - Filters used to refine results
       * @param {string} [parameters.section='Products'] - The section name for results
       * @param {object} [parameters.fmtOptions] - The format options used to refine result groups. Please refer to https://docs.constructor.com/reference/browse-browse-results for details
       * @param {string[]} [parameters.hiddenFields] - Hidden metadata fields to return
       * @param {string[]} [parameters.hiddenFacets] - Hidden facets to return
       * @param {object} [parameters.variationsMap] - The variations map object to aggregate variations. Please refer to https://docs.constructor.com/reference/shared-variations-mapping for details
       * @param {object} [parameters.filterMatchTypes] - An object specifying whether results must match `all`, `any` or `none` of a given filter. Please refer to https://docs.constructor.com/reference/v1-browse-get-browse-items-results
       * @param {object} [parameters.preFilterExpression] - Faceting expression to scope browse results. Please refer to https://docs.constructor.com/reference/configuration-collections
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {Promise}
       * @see https://docs.constructor.com/reference/v1-browse-get-browse-items-results
       * @example
       * constructorio.browse.getBrowseResultsForItemIds(['shirt-123', 'shirt-456', 'shirt-789'], {
       *     filters: {
       *         size: 'medium'
       *     },
       *     filterMatchTypes: {
       *        size: 'all'
       *     }
       * });
       */
    }, {
      key: "getBrowseResultsForItemIds",
      value: function(e, t) {
        var _ = this, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, c, S = this.options.fetch, s;
        if (typeof AbortController == "function") {
          var i = new AbortController();
          s = i && i.signal, f.applyNetworkTimeout(this.options, n, i);
        }
        try {
          c = m(e, t, this.options);
        } catch (r) {
          return Promise.reject(r);
        }
        return S(c, {
          signal: s
        }).then(f.convertResponseToJson).then(function(r) {
          if (r.response && r.response.results)
            return r.result_id && r.response.results.forEach(function(u) {
              u.result_id = r.result_id;
            }), _.eventDispatcher.queue("browse.getBrowseResultsForItemIds.completed", r), r;
          throw new Error("getBrowseResultsForItemIds response data is malformed");
        });
      }
      /**
       * Retrieve browse groups from API
       *
       * @function getBrowseGroups
       * @param {object} [parameters.filters] - Filters used to refine results
       * @param {string} [parameters.section='Products'] - The section name for results
       * @param {object} [parameters.fmtOptions] - The format options used to refine result groups. Please refer to https://docs.constructor.com/reference/v1-browse-get-browse-groups/ for details
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {Promise}
       * @see https://docs.constructor.com/reference/v1-browse-get-browse-groups
       * @example
       * constructorio.browse.getBrowseGroups({
       *     filters: {
       *         group_id: 'drill_collection'
       *     },
       *     fmtOptions: {
       *         groups_max_depth: 2
       *     }
       * });
       */
    }, {
      key: "getBrowseGroups",
      value: function(e) {
        var t = this, _ = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = this.options.fetch, c = this.options.serviceUrl, S = a(e, this.options), s;
        if (typeof AbortController == "function") {
          var i = new AbortController();
          s = i && i.signal, f.applyNetworkTimeout(this.options, _, i);
        }
        delete S._dt;
        var r = f.stringify(S), u = "".concat(c, "/browse/groups?").concat(r);
        return n(u, {
          signal: s
        }).then(f.convertResponseToJson).then(function(o) {
          if (o.response && o.response.groups)
            return t.eventDispatcher.queue("browse.getBrowseGroups.completed", o), o;
          throw new Error("getBrowseGroups response data is malformed");
        });
      }
      /**
       * Retrieve browse facets from API
       *
       * @function getBrowseFacets
       * @param {object} [parameters] - Additional parameters to refine result set
       * @param {number} [parameters.page] - The page number of the results (Can't be used together with offset)
       * @param {number} [parameters.offset] - The number of results to skip from the beginning (Can't be used together with page)
       * @param {string} [parameters.section='Products'] - The section name for results
       * @param {object} [parameters.fmtOptions] - The format options used to refine result groups. Please refer to https://docs.constructor.com/reference/browse-browse-facets/ for details
       * @param {number} [parameters.resultsPerPage] - The number of results per page to return
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {Promise}
       * @see https://docs.constructor.com/reference/browse-browse-facets
       * @example
       * constructorio.browse.getBrowseFacets({
       *     page: 1,
       *     resultsPerPage: 10,
       * });
       */
    }, {
      key: "getBrowseFacets",
      value: function(e, t) {
        var _ = this, n, c = this.options.fetch, S;
        if (typeof AbortController == "function") {
          var s = new AbortController();
          S = s && s.signal, f.applyNetworkTimeout(this.options, t, s);
        }
        try {
          n = p(e, this.options);
        } catch (i) {
          return Promise.reject(i);
        }
        return c(n, {
          signal: S
        }).then(f.convertResponseToJson).then(function(i) {
          if (i.response && i.response.facets)
            return _.eventDispatcher.queue("browse.getBrowseFacets.completed", i), i;
          throw new Error("getBrowseFacets response data is malformed");
        });
      }
      /**
       * Retrieve facet options from API
       *
       * @function getBrowseFacetOptions
       * @param {string} facetName - Name of the facet whose options to return
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @param {object} [parameters] - Additional parameters to refine result set
       * @param {string} [parameters.section='Products'] - The section name for results
       * @param {object} [parameters.fmtOptions] - The format options used to refine result groups. Please refer to https://docs.constructor.com/reference/v1-browse-get-browse-facet-options for details
       * @param {}
       * @returns {Promise}
       * @see https://docs.constructor.com/reference/v1-browse-get-browse-facet-options
       * @example
       * constructorio.browse.getBrowseFacetOptions('price', {
       * });
       */
    }, {
      key: "getBrowseFacetOptions",
      value: function(e) {
        var t = this, _ = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, c, S = this.options.fetch, s;
        if (typeof AbortController == "function") {
          var i = new AbortController();
          s = i && i.signal, f.applyNetworkTimeout(this.options, n, i);
        }
        try {
          c = A(e, _, this.options);
        } catch (r) {
          return Promise.reject(r);
        }
        return S(c, {
          signal: s
        }).then(f.convertResponseToJson).then(function(r) {
          if (r.response && r.response.facets)
            return t.eventDispatcher.queue("browse.getBrowseFacetOptions.completed", r), r;
          throw new Error("getBrowseFacetOptions response data is malformed");
        });
      }
    }]);
  }();
  return Ne = C, Ne;
}
var Le, wt;
function ir() {
  if (wt)
    return Le;
  wt = 1;
  var h = te, E = h(oe()), x = h(se()), q = ve(), b = ne(), g = b.convertResponseToJson, d = b.cleanParams, f = b.applyNetworkTimeout, a = b.trimNonBreakingSpaces, w = b.encodeURIComponentRFC3986, m = b.stringify;
  function p(C, v, l) {
    var e = l.apiKey, t = l.version, _ = l.serviceUrl, n = l.sessionId, c = l.clientId, S = l.userId, s = l.segments, i = l.testCells, r = {
      c: t
    };
    if (r.key = e, r.i = c, r.s = n, !C || typeof C != "string")
      throw new Error("query is a required parameter of type string");
    if (i && Object.keys(i).forEach(function(I) {
      r["ef-".concat(I)] = i[I];
    }), s && s.length && (r.us = s), S && (r.ui = String(S)), v) {
      var u = v.numResults, o = v.resultsPerSection, y = v.filters, k = v.filtersPerSection, R = v.hiddenFields, O = v.variationsMap, N = v.preFilterExpression, T = v.qsParam, U = v.fmtOptions;
      u && (r.num_results = u), o && Object.keys(o).forEach(function(I) {
        r["num_results_".concat(I)] = o[I];
      }), y && (r.filters = y), k && Object.keys(k).forEach(function(I) {
        r["filters[".concat(I, "]")] = k[I];
      }), N && (r.pre_filter_expression = JSON.stringify(N)), U && (r.fmt_options = U), R && (r.fmt_options ? r.fmt_options.hidden_fields = R : r.fmt_options = {
        hidden_fields: R
      }), O && (r.variations_map = JSON.stringify(O)), T && (r.qs = JSON.stringify(T));
    }
    r._dt = Date.now(), r = d(r);
    var D = m(r), L = C.replace(/^\//, "|");
    return "".concat(_, "/autocomplete/").concat(w(a(L)), "?").concat(D);
  }
  var A = /* @__PURE__ */ function() {
    function C(v) {
      (0, E.default)(this, C), this.options = v || {}, this.eventDispatcher = new q(v.eventDispatcher);
    }
    return (0, x.default)(C, [{
      key: "getAutocompleteResults",
      value: function(l, e) {
        var t = this, _ = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, n, c = this.options.fetch, S;
        if (typeof AbortController == "function") {
          var s = new AbortController();
          S = s && s.signal, f(this.options, _, s);
        }
        try {
          n = p(l, e, this.options);
        } catch (i) {
          return Promise.reject(i);
        }
        return c(n, {
          signal: S
        }).then(g).then(function(i) {
          if (i.sections) {
            if (i.result_id) {
              var r = Object.keys(i.sections);
              r.forEach(function(u) {
                var o = i.sections[u];
                o.length && o.forEach(function(y) {
                  y.result_id = i.result_id;
                });
              });
            }
            return t.eventDispatcher.queue("autocomplete.getAutocompleteResults.completed", i), i;
          }
          throw new Error("getAutocompleteResults response data is malformed");
        });
      }
    }]);
  }();
  return Le = A, Le;
}
var De, kt;
function nr() {
  if (kt)
    return De;
  kt = 1;
  var h = te, E = h(oe()), x = h(se()), q = ve(), b = ne();
  function g(f, a, w) {
    var m = w.apiKey, p = w.version, A = w.serviceUrl, C = w.sessionId, v = w.userId, l = w.clientId, e = w.segments, t = {
      c: p
    };
    if (t.key = m, t.i = l, t.s = C, !f || typeof f != "string")
      throw new Error("podId is a required parameter of type string");
    if (e && e.length && (t.us = e), v && (t.ui = String(v)), a) {
      var _ = a.numResults, n = a.itemIds, c = a.variationId, S = a.section, s = a.term, i = a.filters, r = a.variationsMap, u = a.hiddenFields, o = a.preFilterExpression, y = a.fmtOptions;
      if (b.isNil(_) || (t.num_results = _), n && (t.item_id = n), c) {
        if (!n || typeof n == "string" && !n.trim())
          throw new Error("itemIds is a required parameter for variationId");
        if (Array.isArray(n) && !n.length)
          throw new Error("At least one itemId is a required parameter for variationId");
        t.variation_id = c;
      }
      S && (t.section = S), s && (t.term = s), i && (t.filters = i), y && (t.fmt_options = y), u && (t.fmt_options ? t.fmt_options.hidden_fields = u : t.fmt_options = {
        hidden_fields: u
      }), r && (t.variations_map = JSON.stringify(r)), o && (t.pre_filter_expression = JSON.stringify(o));
    }
    t = b.cleanParams(t);
    var k = b.stringify(t);
    return "".concat(A, "/recommendations/v1/pods/").concat(b.encodeURIComponentRFC3986(b.trimNonBreakingSpaces(f)), "?").concat(k);
  }
  var d = /* @__PURE__ */ function() {
    function f(a) {
      (0, E.default)(this, f), this.options = a || {}, this.eventDispatcher = new q(a.eventDispatcher);
    }
    return (0, x.default)(f, [{
      key: "getRecommendations",
      value: function(w, m) {
        var p = this, A = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, C, v = this.options.fetch, l;
        if (typeof AbortController == "function") {
          var e = new AbortController();
          l = e && e.signal, b.applyNetworkTimeout(this.options, A, e);
        }
        try {
          C = g(w, m, this.options);
        } catch (t) {
          return Promise.reject(t);
        }
        return v(C, {
          signal: l
        }).then(b.convertResponseToJson).then(function(t) {
          if (t.response && t.response.results)
            return t.result_id && t.response.results.forEach(function(_) {
              _.result_id = t.result_id;
            }), p.eventDispatcher.queue("recommendations.getRecommendations.completed", t), t;
          throw new Error("getRecommendations response data is malformed");
        });
      }
    }]);
  }();
  return De = d, De;
}
var ye = { exports: {} }, bt;
function or() {
  if (bt)
    return ye.exports;
  bt = 1;
  var h = te, E = h(le()), x = (typeof Reflect > "u" ? "undefined" : (0, E.default)(Reflect)) === "object" ? Reflect : null, q = x && typeof x.apply == "function" ? x.apply : function(i, r, u) {
    return Function.prototype.apply.call(i, r, u);
  }, b;
  x && typeof x.ownKeys == "function" ? b = x.ownKeys : Object.getOwnPropertySymbols ? b = function(i) {
    return Object.getOwnPropertyNames(i).concat(Object.getOwnPropertySymbols(i));
  } : b = function(i) {
    return Object.getOwnPropertyNames(i);
  };
  function g(s) {
    console && console.warn && console.warn(s);
  }
  var d = Number.isNaN || function(i) {
    return i !== i;
  };
  function f() {
    f.init.call(this);
  }
  ye.exports = f, ye.exports.once = n, f.EventEmitter = f, f.prototype._events = void 0, f.prototype._eventsCount = 0, f.prototype._maxListeners = void 0;
  var a = 10;
  function w(s) {
    if (typeof s != "function")
      throw new TypeError('The "listener" argument must be of type Function. Received type ' + (0, E.default)(s));
  }
  Object.defineProperty(f, "defaultMaxListeners", {
    enumerable: !0,
    get: function() {
      return a;
    },
    set: function(i) {
      if (typeof i != "number" || i < 0 || d(i))
        throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + i + ".");
      a = i;
    }
  }), f.init = function() {
    (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, f.prototype.setMaxListeners = function(i) {
    if (typeof i != "number" || i < 0 || d(i))
      throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + i + ".");
    return this._maxListeners = i, this;
  };
  function m(s) {
    return s._maxListeners === void 0 ? f.defaultMaxListeners : s._maxListeners;
  }
  f.prototype.getMaxListeners = function() {
    return m(this);
  }, f.prototype.emit = function(i) {
    for (var r = [], u = 1; u < arguments.length; u++)
      r.push(arguments[u]);
    var o = i === "error", y = this._events;
    if (y !== void 0)
      o = o && y.error === void 0;
    else if (!o)
      return !1;
    if (o) {
      var k;
      if (r.length > 0 && (k = r[0]), k instanceof Error)
        throw k;
      var R = new Error("Unhandled error." + (k ? " (" + k.message + ")" : ""));
      throw R.context = k, R;
    }
    var O = y[i];
    if (O === void 0)
      return !1;
    if (typeof O == "function")
      q(O, this, r);
    else
      for (var N = O.length, T = e(O, N), u = 0; u < N; ++u)
        q(T[u], this, r);
    return !0;
  };
  function p(s, i, r, u) {
    var o, y, k;
    if (w(r), y = s._events, y === void 0 ? (y = s._events = /* @__PURE__ */ Object.create(null), s._eventsCount = 0) : (y.newListener !== void 0 && (s.emit("newListener", i, r.listener ? r.listener : r), y = s._events), k = y[i]), k === void 0)
      k = y[i] = r, ++s._eventsCount;
    else if (typeof k == "function" ? k = y[i] = u ? [r, k] : [k, r] : u ? k.unshift(r) : k.push(r), o = m(s), o > 0 && k.length > o && !k.warned) {
      k.warned = !0;
      var R = new Error("Possible EventEmitter memory leak detected. " + k.length + " " + String(i) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      R.name = "MaxListenersExceededWarning", R.emitter = s, R.type = i, R.count = k.length, g(R);
    }
    return s;
  }
  f.prototype.addListener = function(i, r) {
    return p(this, i, r, !1);
  }, f.prototype.on = f.prototype.addListener, f.prototype.prependListener = function(i, r) {
    return p(this, i, r, !0);
  };
  function A() {
    if (!this.fired)
      return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
  }
  function C(s, i, r) {
    var u = {
      fired: !1,
      wrapFn: void 0,
      target: s,
      type: i,
      listener: r
    }, o = A.bind(u);
    return o.listener = r, u.wrapFn = o, o;
  }
  f.prototype.once = function(i, r) {
    return w(r), this.on(i, C(this, i, r)), this;
  }, f.prototype.prependOnceListener = function(i, r) {
    return w(r), this.prependListener(i, C(this, i, r)), this;
  }, f.prototype.removeListener = function(i, r) {
    var u, o, y, k, R;
    if (w(r), o = this._events, o === void 0)
      return this;
    if (u = o[i], u === void 0)
      return this;
    if (u === r || u.listener === r)
      --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete o[i], o.removeListener && this.emit("removeListener", i, u.listener || r));
    else if (typeof u != "function") {
      for (y = -1, k = u.length - 1; k >= 0; k--)
        if (u[k] === r || u[k].listener === r) {
          R = u[k].listener, y = k;
          break;
        }
      if (y < 0)
        return this;
      y === 0 ? u.shift() : t(u, y), u.length === 1 && (o[i] = u[0]), o.removeListener !== void 0 && this.emit("removeListener", i, R || r);
    }
    return this;
  }, f.prototype.off = f.prototype.removeListener, f.prototype.removeAllListeners = function(i) {
    var r, u, o;
    if (u = this._events, u === void 0)
      return this;
    if (u.removeListener === void 0)
      return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : u[i] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete u[i]), this;
    if (arguments.length === 0) {
      var y = Object.keys(u), k;
      for (o = 0; o < y.length; ++o)
        k = y[o], k !== "removeListener" && this.removeAllListeners(k);
      return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
    }
    if (r = u[i], typeof r == "function")
      this.removeListener(i, r);
    else if (r !== void 0)
      for (o = r.length - 1; o >= 0; o--)
        this.removeListener(i, r[o]);
    return this;
  };
  function v(s, i, r) {
    var u = s._events;
    if (u === void 0)
      return [];
    var o = u[i];
    return o === void 0 ? [] : typeof o == "function" ? r ? [o.listener || o] : [o] : r ? _(o) : e(o, o.length);
  }
  f.prototype.listeners = function(i) {
    return v(this, i, !0);
  }, f.prototype.rawListeners = function(i) {
    return v(this, i, !1);
  }, f.listenerCount = function(s, i) {
    return typeof s.listenerCount == "function" ? s.listenerCount(i) : l.call(s, i);
  }, f.prototype.listenerCount = l;
  function l(s) {
    var i = this._events;
    if (i !== void 0) {
      var r = i[s];
      if (typeof r == "function")
        return 1;
      if (r !== void 0)
        return r.length;
    }
    return 0;
  }
  f.prototype.eventNames = function() {
    return this._eventsCount > 0 ? b(this._events) : [];
  };
  function e(s, i) {
    for (var r = new Array(i), u = 0; u < i; ++u)
      r[u] = s[u];
    return r;
  }
  function t(s, i) {
    for (; i + 1 < s.length; i++)
      s[i] = s[i + 1];
    s.pop();
  }
  function _(s) {
    for (var i = new Array(s.length), r = 0; r < i.length; ++r)
      i[r] = s[r].listener || s[r];
    return i;
  }
  function n(s, i) {
    return new Promise(function(r, u) {
      function o(k) {
        s.removeListener(i, y), u(k);
      }
      function y() {
        typeof s.removeListener == "function" && s.removeListener("error", o), r([].slice.call(arguments));
      }
      S(s, i, y, {
        once: !0
      }), i !== "error" && c(s, o, {
        once: !0
      });
    });
  }
  function c(s, i, r) {
    typeof s.on == "function" && S(s, "error", i, r);
  }
  function S(s, i, r, u) {
    if (typeof s.on == "function")
      u.once ? s.once(i, r) : s.on(i, r);
    else if (typeof s.addEventListener == "function")
      s.addEventListener(i, function o(y) {
        u.once && s.removeEventListener(i, o), r(y);
      });
    else
      throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + (0, E.default)(s));
  }
  return ye.exports;
}
var Be, qt;
function sr() {
  return qt || (qt = 1, Be = ["Googlebot/", "Googlebot-Mobile", "Googlebot-Image", "Googlebot-News", "Googlebot-Video", "AdsBot-Google([^-]|$)", "AdsBot-Google-Mobile", "Feedfetcher-Google", "Mediapartners-Google", "Mediapartners \\(Googlebot\\)", "APIs-Google", "bingbot", "Slurp", "[wW]get", "curl", "LinkedInBot", "Python-urllib", "python-requests", "libwww", "httpunit", "nutch", "Go-http-client", "phpcrawl", "msnbot", "jyxobot", "FAST-WebCrawler", "FAST Enterprise Crawler", "BIGLOTRON", "Teoma", "convera", "seekbot", "Gigabot", "Gigablast", "exabot", "ia_archiver", "GingerCrawler", "webmon ", "HTTrack", "grub\\.org", "UsineNouvelleCrawler", "antibot", "netresearchserver", "speedy", "fluffy", "bibnum\\.bnf", "findlink", "msrbot", "panscient", "yacybot", "AISearchBot", "ips-agent", "tagoobot", "MJ12bot", "woriobot", "yanga", "buzzbot", "mlbot", "YandexBot", "yandex\\.com/bots", "purebot", "Linguee Bot", "CyberPatrol", "voilabot", "Baiduspider", "citeseerxbot", "spbot", "twengabot", "postrank", "turnitinbot", "scribdbot", "page2rss", "sitebot", "linkdex", "Adidxbot", "blekkobot", "ezooms", "dotbot", "Mail\\.RU_Bot", "discobot", "heritrix", "findthatfile", "europarchive\\.org", "NerdByNature\\.Bot", "sistrix crawler", "Ahrefs(Bot|SiteAudit)", "fuelbot", "CrunchBot", "centurybot9", "IndeedBot", "mappydata", "woobot", "ZoominfoBot", "PrivacyAwareBot", "Multiviewbot", "SWIMGBot", "Grobbot", "eright", "Apercite", "semanticbot", "Aboundex", "domaincrawler", "wbsearchbot", "summify", "CCBot", "edisterbot", "seznambot", "ec2linkfinder", "gslfbot", "aiHitBot", "intelium_bot", "facebookexternalhit", "Yeti", "RetrevoPageAnalyzer", "lb-spider", "Sogou", "lssbot", "careerbot", "wotbox", "wocbot", "ichiro", "DuckDuckBot", "lssrocketcrawler", "drupact", "webcompanycrawler", "acoonbot", "openindexspider", "gnam gnam spider", "web-archive-net\\.com\\.bot", "backlinkcrawler", "coccoc", "integromedb", "content crawler spider", "toplistbot", "it2media-domain-crawler", "ip-web-crawler\\.com", "siteexplorer\\.info", "elisabot", "proximic", "changedetection", "arabot", "WeSEE:Search", "niki-bot", "CrystalSemanticsBot", "rogerbot", "360Spider", "psbot", "InterfaxScanBot", "CC Metadata Scaper", "g00g1e\\.net", "GrapeshotCrawler", "urlappendbot", "brainobot", "fr-crawler", "binlar", "SimpleCrawler", "Twitterbot", "cXensebot", "smtbot", "bnf\\.fr_bot", "A6-Indexer", "ADmantX", "Facebot", "OrangeBot/", "memorybot", "AdvBot", "MegaIndex", "SemanticScholarBot", "ltx71", "nerdybot", "xovibot", "BUbiNG", "Qwantify", "archive\\.org_bot", "Applebot", "TweetmemeBot", "crawler4j", "findxbot", "S[eE][mM]rushBot", "yoozBot", "lipperhey", "Y!J", "Domain Re-Animator Bot", "AddThis", "Screaming Frog SEO Spider", "MetaURI", "Scrapy", "Livelap[bB]ot", "OpenHoseBot", "CapsuleChecker", "collection@infegy\\.com", "IstellaBot", "DeuSu/", "betaBot", "Cliqzbot/", "MojeekBot/", "netEstate NE Crawler", "SafeSearch microdata crawler", "Gluten Free Crawler/", "Sonic", "Sysomos", "Trove", "deadlinkchecker", "Slack-ImgProxy", "Embedly", "RankActiveLinkBot", "iskanie", "SafeDNSBot", "SkypeUriPreview", "Veoozbot", "Slackbot", "redditbot", "datagnionbot", "Google-Adwords-Instant", "adbeat_bot", "WhatsApp", "contxbot", "pinterest", "electricmonk", "GarlikCrawler", "BingPreview/", "vebidoobot", "FemtosearchBot", "Yahoo Link Preview", "MetaJobBot", "DomainStatsBot", "mindUpBot", "Daum/", "Jugendschutzprogramm-Crawler", "Xenu Link Sleuth", "Pcore-HTTP", "moatbot", "KosmioBot", "pingdom", "PhantomJS", "Gowikibot", "PiplBot", "Discordbot", "TelegramBot", "Jetslide", "newsharecounts", "James BOT", "Barkrowler", "TinEye", "SocialRankIOBot", "trendictionbot", "Ocarinabot", "epicbot", "Primalbot", "DuckDuckGo-Favicons-Bot", "GnowitNewsbot", "Leikibot", "LinkArchiver", "YaK/", "PaperLiBot", "Digg Deeper", "dcrawl", "Snacktory", "AndersPinkBot", "Fyrebot", "EveryoneSocialBot", "Mediatoolkitbot", "Luminator-robots", "ExtLinksBot", "SurveyBot", "NING/", "okhttp", "Nuzzel", "omgili", "PocketParser", "YisouSpider", "um-LN", "ToutiaoSpider", "MuckRack", "Jamie's Spider", "AHC/", "NetcraftSurveyAgent", "Laserlikebot", "Apache-HttpClient", "AppEngine-Google", "Jetty", "Upflow", "Thinklab", "Traackr\\.com", "Twurly", "Mastodon", "http_get", "DnyzBot", "botify", "007ac9 Crawler", "BehloolBot", "BrandVerity", "check_http", "BDCbot", "ZumBot", "EZID", "ICC-Crawler", "ArchiveBot", "^LCC ", "filterdb\\.iss\\.net/crawler", "BLP_bbot", "BomboraBot", "Buck/", "Companybook-Crawler", "Genieo", "magpie-crawler", "MeltwaterNews", "Moreover", "newspaper/", "ScoutJet", "(^| )sentry/", "StorygizeBot", "UptimeRobot", "OutclicksBot", "seoscanners", "Hatena", "Google Web Preview", "MauiBot", "AlphaBot", "SBL-BOT", "IAS crawler", "adscanner", "Netvibes", "acapbot", "Baidu-YunGuanCe", "bitlybot", "blogmuraBot", "Bot\\.AraTurka\\.com", "bot-pge\\.chlooe\\.com", "BoxcarBot", "BTWebClient", "ContextAd Bot", "Digincore bot", "Disqus", "Feedly", "Fetch/", "Fever", "Flamingo_SearchEngine", "FlipboardProxy", "g2reader-bot", "imrbot", "K7MLWCBot", "Kemvibot", "Landau-Media-Spider", "linkapediabot", "vkShare", "Siteimprove\\.com", "BLEXBot/", "DareBoost", "ZuperlistBot/", "Miniflux/", "Feedspotbot/", "Diffbot/", "SEOkicks", "tracemyfile", "Nimbostratus-Bot", "Bytespider", "BTTAgent", "OnCrawl"]), Be;
}
var Pe, mt;
function ur() {
  if (mt)
    return Pe;
  mt = 1;
  var h = te, E = h(oe()), x = h(se()), q = it(), b = sr(), g = ne(), d = "_constructorio_is_human", f = ["scroll", "resize", "touchmove", "mouseover", "mousemove", "keydown", "keypress", "keyup", "focus"], a = /* @__PURE__ */ function() {
    function w() {
      var m = this, p = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      (0, E.default)(this, w);
      var A = p.humanityCheckLocation;
      this.store = A === "local" ? q.local : q.session, this.hasPerformedHumanEvent = this.getIsHumanFromStorage();
      var C = function() {
        m.hasPerformedHumanEvent = !0, m.store.set(d, !0), f.forEach(function(l) {
          g.removeEventListener(l, C, !0);
        });
      };
      this.hasPerformedHumanEvent || f.forEach(function(v) {
        g.addEventListener(v, C, !0);
      });
    }
    return (0, x.default)(w, [{
      key: "getIsHumanFromStorage",
      value: function() {
        return !!this.store.get(d) || !1;
      }
      // Backward-compatible alias
    }, {
      key: "getIsHumanFromSessionStorage",
      value: function() {
        return !!q.session.get(d) || !1;
      }
      // Return boolean indicating if user is a bot
      // ...if it has a bot-like useragent
      // ...or uses webdriver
      // ...or has not performed a human event
    }, {
      key: "isBot",
      value: function() {
        var p = g.getNavigator(), A = p.userAgent, C = p.webdriver, v = new RegExp("(".concat(b.join("|"), ")"));
        return !!(A.match(v) || C || !this.getIsHumanFromStorage());
      }
    }]);
  }();
  return Pe = a, Pe;
}
var je, St;
function ar() {
  if (St)
    return je;
  St = 1;
  var h = te, E = h(oe()), x = h(se()), q = it(), b = ur(), g = ne(), d = ne(), f = d.obfuscatePiiRequest, a = "_constructorio_requests", w = 18e4, m = /* @__PURE__ */ function() {
    function p(A, C) {
      var v = this;
      (0, E.default)(this, p), this.options = A, this.eventemitter = C, this.humanity = new b(A), this.requestPending = !1, this.pageUnloading = !1, this.sendTrackingEvents = !!(A && A.sendTrackingEvents === !0), g.addEventListener("visibilitychange", function() {
        document.visibilityState === "hidden" ? v.pageUnloading = !0 : document.visibilityState === "visible" && v.pageUnloading === !0 && (v.pageUnloading = !1, v.sendTrackingEvents && v.send());
      }), this.sendTrackingEvents && this.send();
    }
    return (0, x.default)(p, [{
      key: "queue",
      value: function(C) {
        var v = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "GET", l = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, e = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
        if (this.sendTrackingEvents && (!g.canUseDOM() || !this.humanity.isBot())) {
          var t = p.get(), _ = f(C);
          t.push({
            url: _,
            method: v,
            body: l,
            networkParameters: e
          }), p.set(t);
        }
      }
      // Read from queue and send events to server
    }, {
      key: "sendEvents",
      value: function() {
        var C = this, v = this.options.fetch, l = p.get();
        if (
          // Consider user "human" if no DOM context is available
          (!g.canUseDOM() || !this.humanity.isBot()) && !this.requestPending && !this.pageUnloading && l.length
        ) {
          var e, t = l.shift(), _ = t, n = _.networkParameters, c, S = this;
          if (p.set(l), n && typeof AbortController == "function") {
            var s = new AbortController();
            c = s.signal, g.applyNetworkTimeout(this.options, n, s);
          }
          if (typeof t == "string" && (t = {
            url: t,
            method: "GET"
          }), t.url) {
            var i = t.url.match(/\?.*_dt=([^&]+)/), r = parseInt(i && i[1], 10), u = +/* @__PURE__ */ new Date();
            if (r && Number.isInteger(r) && u - r > w) {
              this.sendTrackingEvents = !1, p.remove();
              return;
            }
          }
          t.method === "GET" && (e = v(t.url, {
            signal: c
          })), t.method === "POST" && (e = v(t.url, {
            method: t.method,
            body: JSON.stringify(t.body),
            mode: "cors",
            headers: {
              "Content-Type": "text/plain"
            },
            signal: c
          })), e && (this.requestPending = !0, e.then(function(o) {
            o.ok ? (S.eventemitter && S.eventemitter.emit("success", {
              url: t.url,
              method: t.method,
              message: "ok"
            }), C.requestPending = !1, C.send()) : o.json().then(function(y) {
              S.eventemitter && S.eventemitter.emit("error", {
                url: t.url,
                method: t.method,
                message: y && y.message
              }), C.requestPending = !1, C.send();
            }).catch(function(y) {
              S.eventemitter && S.eventemitter.emit("error", {
                url: t.url,
                method: t.method,
                message: y.type
              }), C.requestPending = !1, C.send();
            });
          }).catch(function(o) {
            S.eventemitter && S.eventemitter.emit("error", {
              url: t.url,
              method: t.method,
              message: o && o.toString && o.toString()
            }), C.requestPending = !1, C.send();
          }));
        }
      }
      // Read from queue and send requests to server
    }, {
      key: "send",
      value: function() {
        this.sendTrackingEvents && (this.options && this.options.trackingSendDelay === 0 ? this.sendEvents() : setTimeout(this.sendEvents.bind(this), this.options && this.options.trackingSendDelay || 250));
      }
      // Return current request queue
    }], [{
      key: "get",
      value: function() {
        return q.local.get(a) || [];
      }
      // Update current request queue
    }, {
      key: "set",
      value: function(C) {
        !C || Array.isArray(C) && C.length === 0 ? p.remove() : q.local.set(a, C);
        var v = p.get();
        Array.isArray(v) && v.length !== C.length && (this.sendTrackingEvents = !1, p.remove());
      }
      // Remove current request queue key
    }, {
      key: "remove",
      value: function() {
        q.local.remove(a);
      }
    }]);
  }();
  return je = m, je;
}
var Fe, Et;
function cr() {
  if (Et)
    return Fe;
  Et = 1;
  var h = te, E = h(le()), x = h(ke()), q = h(oe()), b = h(se());
  function g(v, l) {
    var e = Object.keys(v);
    if (Object.getOwnPropertySymbols) {
      var t = Object.getOwnPropertySymbols(v);
      l && (t = t.filter(function(_) {
        return Object.getOwnPropertyDescriptor(v, _).enumerable;
      })), e.push.apply(e, t);
    }
    return e;
  }
  function d(v) {
    for (var l = 1; l < arguments.length; l++) {
      var e = arguments[l] != null ? arguments[l] : {};
      l % 2 ? g(Object(e), !0).forEach(function(t) {
        (0, x.default)(v, t, e[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(v, Object.getOwnPropertyDescriptors(e)) : g(Object(e)).forEach(function(t) {
        Object.defineProperty(v, t, Object.getOwnPropertyDescriptor(e, t));
      });
    }
    return v;
  }
  var f = or(), a = ne(), w = ar(), m = 2048;
  function p(v, l) {
    var e = l.apiKey, t = l.version, _ = l.sessionId, n = l.clientId, c = l.userId, S = l.segments, s = l.testCells, i = l.requestMethod, r = l.beaconMode, u = a.getWindowLocation(), o = u.host, y = u.pathname, k = u.search, R = a.getCanonicalUrl(), O = a.getDocumentReferrer(), N = l.sendReferrerWithTrackingEvents !== !1, T = Object.assign(v);
    if (t && (T.c = t), n && (T.i = n), _ && (T.s = _), c && (T.ui = String(c)), S && S.length && (T.us = S), e && (T.key = e), O && (T.document_referrer = O), R && (T.canonical_url = R), s && Object.keys(s).forEach(function(L) {
      T["ef-".concat(L)] = s[L];
    }), r && i && i.match(/POST/i) && (T.beacon = !0), N && o && (T.origin_referrer = o, y && (T.origin_referrer += y), k))
      try {
        var U = [], D = new URLSearchParams(k);
        D.forEach(function(L, I) {
          I.match(/utm_/) && U.push("".concat(I, "=").concat(L));
        }), U.length && (T.origin_referrer += "?".concat(U.join("&")));
      } catch {
      }
    return T._dt = Date.now(), T = a.cleanParams(T), T;
  }
  function A(v, l) {
    return a.stringify(p(v, l));
  }
  var C = /* @__PURE__ */ function() {
    function v(l) {
      (0, q.default)(this, v), this.options = l || {}, this.eventemitter = new f(), this.requests = new w(l, this.eventemitter);
    }
    return (0, b.default)(v, [{
      key: "trackSessionStartV2",
      value: function() {
        var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = "".concat(this.options.serviceUrl, "/v2/behavioral_action/session_start?");
        return this.requests.queue("".concat(t).concat(A({}, this.options)), "POST", void 0, e), this.requests.send(), !0;
      }
      /**
       * Send session start event to API
       *
       * @function trackSessionStart
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @example
       * constructorio.tracker.trackSessionStart();
       */
    }, {
      key: "trackSessionStart",
      value: function() {
        var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = "".concat(this.options.serviceUrl, "/behavior?"), _ = {
          action: "session_start"
        };
        return this.requests.queue("".concat(t).concat(A(_, this.options)), void 0, void 0, e), this.requests.send(), !0;
      }
      /**
       * Send input focus event to API
       * @private
       * @function trackInputFocusV2
       * @param {string} userInput - The current autocomplete search query
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {object} [parameters.analyticsTags] - Pass additional analytics data
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User focused on search input element
       * @example
       * constructorio.tracker.trackInputFocusV2("text");
       */
    }, {
      key: "trackInputFocusV2",
      value: function() {
        var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, n = "".concat(this.options.serviceUrl, "/v2/behavioral_action/focus?"), c = {}, S = t.analyticsTags, s = S === void 0 ? null : S;
        s && (c.analytics_tags = s), c.user_input = e;
        var i = "POST", r = p(c, d(d({}, this.options), {}, {
          requestMethod: i
        }));
        return this.requests.queue("".concat(n).concat(A({}, this.options)), i, r, _), this.requests.send(), !0;
      }
      /**
       * Send input focus event to API
       *
       * @function trackInputFocus
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User focused on search input element
       * @example
       * constructorio.tracker.trackInputFocus();
       */
    }, {
      key: "trackInputFocus",
      value: function() {
        var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = "".concat(this.options.serviceUrl, "/behavior?"), _ = {
          action: "focus"
        };
        return this.requests.queue("".concat(t).concat(A(_, this.options)), void 0, void 0, e), this.requests.send(), !0;
      }
      /**
       * Send item detail load event to API
       *
       * @function trackItemDetailLoad
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.itemName - Product item name
       * @param {string} parameters.itemId - Product item unique identifier
       * @param {string} parameters.url - Current page URL
       * @param {object} [parameters.analyticsTags] - Pass additional analytics data
       * @param {string} [parameters.variationId] - Product item variation unique identifier
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User loaded an item detail page
       * @example
       * constructorio.tracker.trackItemDetailLoad(
       *     {
       *         itemName: 'Red T-Shirt',
       *         itemId: 'KMH876',
       *         url: 'https://constructor.io/product/KMH876',
       *     },
       * );
       */
    }, {
      key: "trackItemDetailLoad",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, E.default)(e) === "object" && !Array.isArray(e)) {
          var _ = "".concat(this.options.serviceUrl, "/v2/behavioral_action/item_detail_load?"), n = {}, c = {}, S = e.item_name, s = e.name, i = e.item_id, r = e.customer_id, u = e.customerId, o = u === void 0 ? r : u, y = e.variation_id, k = e.itemName, R = k === void 0 ? S || s : k, O = e.itemId, N = O === void 0 ? i || o : O, T = e.variationId, U = T === void 0 ? y : T, D = e.url, L = e.analyticsTags;
          R && (c.item_name = R), N && (c.item_id = N), U && (c.variation_id = U), L && (c.analytics_tags = L), D && (c.url = a.truncateString(D, m));
          var I = "".concat(_).concat(A(n, this.options)), B = "POST", P = p(c, d(d({}, this.options), {}, {
            requestMethod: B
          }));
          return this.requests.queue(I, B, P, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters are required of type object");
      }
      /**
       * Send autocomplete select event to API
       * @private
       * @function trackAutocompleteSelectV2
       * @param {string} itemName - Name of selected autocomplete item
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.userInput - The current autocomplete search query
       * @param {string} [parameters.section] - Section the selected item resides within
       * @param {string} [parameters.tr] - Trigger used to select the item (click, etc.)
       * @param {string} [parameters.itemId] - Item id of the selected item
       * @param {string} [parameters.variationId] - Variation id of the selected item
       * @param {string} [parameters.groupId] - Group identifier of the group to search within. Only required if searching within a group, i.e. "Pumpkin in Canned Goods"
       * @param {string} [parameters.slCampaignId] - Pass campaign id of sponsored listing
       * @param {string} [parameters.slCampaignOwner] - Pass campaign owner of sponsored listing
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User selected (clicked, or navigated to via keyboard) a result that appeared within autocomplete
       * @example
       * constructorio.tracker.trackAutocompleteSelectV2(
       *     'T-Shirt',
       *      {
       *          userInput: 'Shirt',
       *          section: 'Products',
       *          tr: 'click',
       *          groupId: '88JU230',
       *          itemId: '12345',
       *          variationId: '12345-A',
       *          slCampaignId: 'Campaign 123',
       *          slCampaignOwner: 'Store 123',
       *      },
       * );
       */
    }, {
      key: "trackAutocompleteSelectV2",
      value: function(e, t) {
        var _ = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        if (e && typeof e == "string") {
          if (t && (0, E.default)(t) === "object" && !Array.isArray(t)) {
            var n = "".concat(this.options.serviceUrl, "/v2/behavioral_action/autocomplete_select?"), c = t.original_query, S = t.originalQuery, s = S === void 0 ? c : S, i = t.user_input, r = t.userInput, u = r === void 0 ? s || i : r, o = t.original_section, y = t.section, k = y === void 0 ? o : y, R = t.tr, O = t.group_id, N = t.groupId, T = N === void 0 ? O : N, U = t.item_id, D = t.itemId, L = D === void 0 ? U : D, I = t.variation_id, B = t.variationId, P = B === void 0 ? I : B, F = t.slCampaignId, J = t.slCampaignOwner, M = {}, j = {
              user_input: u,
              tr: R,
              group_id: T,
              item_id: L,
              variation_id: P,
              item_name: e,
              section: k
            };
            k && (M.section = k), F && (j.sl_campaign_id = F), J && (j.sl_campaign_owner = J);
            var V = "".concat(n).concat(A(M, this.options)), G = "POST", K = p(j, d(d({}, this.options), {}, {
              requestMethod: G
            }));
            return this.requests.queue(V, G, K, _), this.requests.send(), !0;
          }
          return this.requests.send(), new Error("parameters are required of type object");
        }
        return this.requests.send(), new Error("term is a required parameter of type string");
      }
      /**
       * Send autocomplete select event to API
       *
       * @function trackAutocompleteSelect
       * @param {string} term - Term of selected autocomplete item
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.originalQuery - The current autocomplete search query
       * @param {string} parameters.section - Section the selected item resides within
       * @param {string} [parameters.tr] - Trigger used to select the item (click, etc.)
       * @param {string} [parameters.groupId] - Group identifier of the group to search within. Only required if searching within a group, i.e. "Pumpkin in Canned Goods"
       * @param {string} [parameters.displayName] - Display name of group of selected item
       * @param {string} [parameters.itemId] - Item id of the selected item
       * @param {string} [parameters.slCampaignId] - Pass campaign id of sponsored listing
       * @param {string} [parameters.slCampaignOwner] - Pass campaign owner of sponsored listing
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User selected (clicked, or navigated to via keyboard) a result that appeared within autocomplete
       * @example
       * constructorio.tracker.trackAutocompleteSelect(
       *     'T-Shirt',
       *      {
       *         originalQuery: 'Shirt',
       *         section: 'Products',
       *         tr: 'click',
       *         groupId: '88JU230',
       *         displayName: 'apparel',
       *         itemId: '12345',
       *         slCampaignId: 'Campaign 123',
       *         slCampaignOwner: 'Store 123',
       *      },
       * );
       */
    }, {
      key: "trackAutocompleteSelect",
      value: function(e, t) {
        var _ = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        if (e && typeof e == "string") {
          if (t && (0, E.default)(t) === "object" && !Array.isArray(t)) {
            var n = "".concat(this.options.serviceUrl, "/autocomplete/").concat(a.encodeURIComponentRFC3986(a.trimNonBreakingSpaces(e)), "/select?"), c = {}, S = t.original_query, s = t.originalQuery, i = s === void 0 ? S : s, r = t.section, u = t.original_section, o = t.originalSection, y = o === void 0 ? u : o, k = t.tr, R = t.group_id, O = t.groupId, N = O === void 0 ? R : O, T = t.display_name, U = t.displayName, D = U === void 0 ? T : U, L = t.item_id, I = t.itemId, B = I === void 0 ? L : I, P = t.slCampaignOwner, F = t.slCampaignId;
            return i && (c.original_query = i), k && (c.tr = k), (y || r) && (c.section = y || r), N && (c.group = {
              group_id: N,
              display_name: D
            }), B && (c.item_id = B), F && (c.sl_campaign_id = F), P && (c.sl_campaign_owner = P), this.requests.queue("".concat(n).concat(A(c, this.options)), void 0, void 0, _), this.requests.send(), !0;
          }
          return this.requests.send(), new Error("parameters are required of type object");
        }
        return this.requests.send(), new Error("term is a required parameter of type string");
      }
      /**
       * Send autocomplete search event to API
       * @private
       * @function trackSearchSubmitV2
       * @param {string} searchTerm - Term of submitted autocomplete event
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.userInput - The current autocomplete search query
       * @param {string} [parameters.groupId] - Group identifier of the group to search within. Only required if searching within a group, i.e. "Pumpkin in Canned Goods"
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {object} [parameters.analyticsTags] - Pass additional analytics data
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User submitted a search (pressing enter within input element, or clicking submit element)
       * @example
       * constructorio.tracker.trackSearchSubmitV2(
       *     'T-Shirt',
       *     {
       *         userInput: 'Shirt',
       *         groupId: '88JU230',
       *     },
       * );
       */
    }, {
      key: "trackSearchSubmitV2",
      value: function(e, t) {
        var _ = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        if (e && typeof e == "string") {
          if (t && (0, E.default)(t) === "object" && !Array.isArray(t)) {
            var n = "".concat(this.options.serviceUrl, "/v2/behavioral_action/search_submit?"), c = t.original_query, S = t.originalQuery, s = S === void 0 ? c : S, i = t.user_input, r = t.userInput, u = r === void 0 ? s || i : r, o = t.group_id, y = t.groupId, k = y === void 0 ? o : y, R = t.section, O = t.analyticsTags, N = O === void 0 ? null : O, T = {}, U = {
              user_input: u,
              search_term: e,
              section: R
            };
            k && (U.filters = {
              group_id: k
            }), R && (T.section = R), N && (U.analytics_tags = N);
            var D = "".concat(n).concat(A(T, this.options)), L = "POST", I = p(U, d(d({}, this.options), {}, {
              requestMethod: L
            }));
            return this.requests.queue(D, L, I, _), this.requests.send(), !0;
          }
          return this.requests.send(), new Error("parameters are required of type object");
        }
        return this.requests.send(), new Error("term is a required parameter of type string");
      }
      /**
       * Send autocomplete search event to API
       *
       * @function trackSearchSubmit
       * @param {string} term - Term of submitted autocomplete event
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.originalQuery - The current autocomplete search query
       * @param {string} [parameters.groupId] - Group identifier of the group to search within. Only required if searching within a group, i.e. "Pumpkin in Canned Goods"
       * @param {string} [parameters.displayName] - Display name of group of selected item
       * @param {object} [parameters.analyticsTags] - Pass additional analytics data
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User submitted a search (pressing enter within input element, or clicking submit element)
       * @example
       * constructorio.tracker.trackSearchSubmit(
       *     'T-Shirt',
       *     {
       *         originalQuery: 'Shirt',
       *         groupId: '88JU230',
       *         displayName: 'apparel',
       *     },
       * );
       */
    }, {
      key: "trackSearchSubmit",
      value: function(e, t) {
        var _ = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        if (e && typeof e == "string") {
          if (t && (0, E.default)(t) === "object" && !Array.isArray(t)) {
            var n = "".concat(this.options.serviceUrl, "/autocomplete/").concat(a.encodeURIComponentRFC3986(a.trimNonBreakingSpaces(e)), "/search?"), c = {}, S = t.original_query, s = t.originalQuery, i = s === void 0 ? S : s, r = t.group_id, u = t.groupId, o = u === void 0 ? r : u, y = t.display_name, k = t.displayName, R = k === void 0 ? y : k, O = t.analyticsTags;
            return i && (c.original_query = i), o && (c.group = {
              group_id: o,
              display_name: R
            }), O && (c.analytics_tags = O), this.requests.queue("".concat(n).concat(A(c, this.options)), void 0, void 0, _), this.requests.send(), !0;
          }
          return this.requests.send(), new Error("parameters are required of type object");
        }
        return this.requests.send(), new Error("term is a required parameter of type string");
      }
      /**
       * Send search results loaded event to API
       *
       * @function trackSearchResultsLoaded
       * @param {string} searchTerm - Search results query term
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.url - URL of the search results page
       * @param {object[]} parameters.items - List of product item unique identifiers in search results listing
       * @param {number} [parameters.resultCount] - Total number of results
       * @param {number} [parameters.resultPage] - Current page of search results
       * @param {string} [parameters.resultId] - Browse result identifier (returned in response from Constructor)
       * @param {object} [parameters.selectedFilters] - Selected filters
       * @param {string} [parameters.sortOrder] - Sort order ('ascending' or 'descending')
       * @param {string} [parameters.sortBy] - Sorting method
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {object} [parameters.analyticsTags] - Pass additional analytics data
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User viewed a search product listing page
       * @example
       * constructorio.tracker.trackSearchResultsLoaded(
       *     'T-Shirt',
       *     {
       *         resultCount: 167,
       *         items: [{itemId: 'KMH876'}, {itemId: 'KMH140'}, {itemId: 'KMH437'}],
       *         sortOrder: 'ascending'
       *         sortBy: 'price',
       *         resultPage: 3,
       *         resultCount: 20
       *     },
       * );
       */
    }, {
      key: "trackSearchResultsLoaded",
      value: function(e, t) {
        var _ = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        if (e && typeof e == "string") {
          if (t && (0, E.default)(t) === "object" && !Array.isArray(t)) {
            var n, c, S, s = "".concat(this.options.serviceUrl, "/v2/behavioral_action/search_result_load?"), i = t.num_results, r = t.numResults, u = r === void 0 ? i : r, o = t.result_count, y = t.customerIds, k = t.customer_ids, R = k === void 0 ? y : k, O = t.itemIds, N = t.item_ids, T = N === void 0 ? O : N, U = t.items, D = U === void 0 ? R || T : U, L = t.result_page, I = t.resultPage, B = I === void 0 ? L : I, P = t.result_id, F = t.resultId, J = F === void 0 ? P : F, M = t.sort_order, j = t.sortOrder, V = j === void 0 ? M : j, G = t.sort_by, K = t.sortBy, H = K === void 0 ? G : K, Y = t.selected_filters, z = t.selectedFilters, $ = z === void 0 ? Y : z, X = t.url, Z = X === void 0 ? ((n = a.getWindowLocation()) === null || n === void 0 ? void 0 : n.href) || "N/A" : X, ee = t.section, Q = t.analyticsTags, re = t.resultCount, W = re === void 0 ? (c = (S = u ?? o) !== null && S !== void 0 ? S : D == null ? void 0 : D.length) !== null && c !== void 0 ? c : 0 : re, ue = {}, ie;
            if (D && Array.isArray(D) && D.length !== 0) {
              var ae = D.slice(0, 100);
              typeof D[0] == "string" || typeof D[0] == "number" ? ie = ae.map(function(fe) {
                return {
                  item_id: String(fe)
                };
              }) : ie = ae.map(function(fe) {
                return a.toSnakeCaseKeys(fe, !1);
              });
            }
            ee && (ue.section = ee);
            var _e = {
              search_term: e,
              result_count: W,
              items: ie,
              result_page: B,
              result_id: J,
              sort_order: V,
              sort_by: H,
              selected_filters: $,
              url: a.truncateString(Z, m),
              section: ee,
              analytics_tags: Q
            }, pe = "".concat(s).concat(A(ue, this.options)), de = "POST", be = p(_e, d(d({}, this.options), {}, {
              requestMethod: de
            }));
            return this.requests.queue(pe, de, be, _), this.requests.send(), !0;
          }
          return this.requests.send(), new Error("parameters are required of type object");
        }
        return this.requests.send(), new Error("term is a required parameter of type string");
      }
      /**
       * Send click through event to API
       * @private
       * @function trackSearchResultClickV2
       * @param {string} searchTerm - Search results query term
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.itemName - Product item name (Either itemName or itemId is required)
       * @param {string} parameters.itemId - Product item unique identifier
       * @param {string} [parameters.variationId] - Product item variation unique identifier
       * @param {string} [parameters.resultId] - Search result identifier (returned in response from Constructor)
       * @param {number} [parameters.resultCount] - Number of results in total
       * @param {number} [parameters.resultPage] - Current page of results
       * @param {string} [parameters.resultPositionOnPage] - Position of selected items on page
       * @param {string} [parameters.numResultsPerPage] - Number of results per page
       * @param {object} [parameters.selectedFilters] - Key - Value map of selected filters
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {object} [parameters.analyticsTags] - Pass additional analytics data
       * @param {string} [parameters.slCampaignId] - Pass campaign id of sponsored listing
       * @param {string} [parameters.slCampaignOwner] - Pass campaign owner of sponsored listing
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User clicked a result that appeared within a search product listing page
       * @example
       * constructorio.tracker.trackSearchResultClickV2(
       *     'T-Shirt',
       *     {
       *         itemName: 'Red T-Shirt',
       *         itemId: 'KMH876',
       *         resultId: '019927c2-f955-4020-8b8d-6b21b93cb5a2',
       *         slCampaignId: 'Campaign 123',
       *         slCampaignOwner: 'Store 123',
       *     },
       * );
       */
    }, {
      key: "trackSearchResultClickV2",
      value: function(e, t) {
        var _ = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        if (e && typeof e == "string") {
          if (t && (0, E.default)(t) === "object" && !Array.isArray(t)) {
            var n = "".concat(this.options.serviceUrl, "/v2/behavioral_action/search_result_click?"), c = t.num_results, S = t.customer_id, s = t.item_id, i = t.itemId, r = i === void 0 ? S || s : i, u = t.name, o = t.item_name, y = t.itemName, k = y === void 0 ? u || o : y, R = t.variation_id, O = t.variationId, N = O === void 0 ? R : O, T = t.result_id, U = t.resultId, D = U === void 0 ? T : U, L = t.result_count, I = t.resultCount, B = I === void 0 ? c || L : I, P = t.result_page, F = t.resultPage, J = F === void 0 ? P : F, M = t.result_position_on_page, j = t.resultPositionOnPage, V = j === void 0 ? M : j, G = t.num_results_per_page, K = t.numResultsPerPage, H = K === void 0 ? G : K, Y = t.selected_filters, z = t.selectedFilters, $ = z === void 0 ? Y : z, X = t.section, Z = t.analyticsTags, ee = t.slCampaignId, Q = t.slCampaignOwner, re = {
              sl_campaign_id: ee,
              sl_campaign_owner: Q,
              item_name: k,
              item_id: r,
              variation_id: N,
              result_id: D,
              result_count: B,
              result_page: J,
              result_position_on_page: V,
              num_results_per_page: H,
              selected_filters: $,
              section: X,
              search_term: e,
              analytics_tags: Z
            }, W = {};
            X && (W.section = X);
            var ue = "".concat(n).concat(A(W, this.options)), ie = "POST", ae = p(re, d(d({}, this.options), {}, {
              requestMethod: ie
            }));
            return this.requests.queue(ue, ie, ae, _), this.requests.send(), !0;
          }
          return this.requests.send(), new Error("parameters are required of type object");
        }
        return this.requests.send(), new Error("term is a required parameter of type string");
      }
      /**
       * Send click through event to API
       *
       * @function trackSearchResultClick
       * @param {string} term - Search results query term
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} [parameters.itemName] - Product item name
       * @param {string} parameters.itemId - Product item unique identifier
       * @param {string} [parameters.variationId] - Product item variation unique identifier
       * @param {string} [parameters.resultId] - Search result identifier (returned in response from Constructor)
       * @param {string} [parameters.itemIsConvertible] - Whether or not an item is available for a conversion
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {object} [parameters.analyticsTags] - Pass additional analytics data
       * @param {string} [parameters.slCampaignId] - Pass campaign id of sponsored listing
       * @param {string} [parameters.slCampaignOwner] - Pass campaign owner of sponsored listing
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User clicked a result that appeared within a search product listing page
       * @example
       * constructorio.tracker.trackSearchResultClick(
       *     'T-Shirt',
       *     {
       *         itemName: 'Red T-Shirt',
       *         itemId: 'KMH876',
       *         resultId: '019927c2-f955-4020-8b8d-6b21b93cb5a2',
       *         slCampaignId: 'Campaign 123',
       *         slCampaignOwner: 'Store 123',
       *     },
       * );
       */
    }, {
      key: "trackSearchResultClick",
      value: function(e, t) {
        var _ = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        if (e && typeof e == "string") {
          if (t && (0, E.default)(t) === "object" && !Array.isArray(t)) {
            var n = "".concat(this.options.serviceUrl, "/autocomplete/").concat(a.encodeURIComponentRFC3986(a.trimNonBreakingSpaces(e)), "/click_through?"), c = {}, S = t.item_name, s = t.name, i = t.itemName, r = i === void 0 ? S || s : i, u = t.item_id, o = t.itemId, y = o === void 0 ? u : o, k = t.customer_id, R = t.customerId, O = R === void 0 ? k || y : R, N = t.variation_id, T = t.variationId, U = T === void 0 ? N : T, D = t.result_id, L = t.resultId, I = L === void 0 ? D : L, B = t.item_is_convertible, P = t.itemIsConvertible, F = P === void 0 ? B : P, J = t.section, M = t.analyticsTags, j = t.slCampaignOwner, V = t.slCampaignId;
            return r && (c.name = r), O && (c.customer_id = O), U && (c.variation_id = U), I && (c.result_id = I), typeof F == "boolean" && (c.item_is_convertible = F), J && (c.section = J), M && (c.analytics_tags = M), V && (c.sl_campaign_id = V), j && (c.sl_campaign_owner = j), this.requests.queue("".concat(n).concat(A(c, this.options)), void 0, void 0, _), this.requests.send(), !0;
          }
          return this.requests.send(), new Error("parameters are required of type object");
        }
        return this.requests.send(), new Error("term is a required parameter of type string");
      }
      /**
       * Send conversion event to API
       *
       * @function trackConversion
       * @param {string} [term] - Search results query term that led to conversion event
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.itemId - Product item unique identifier
       * @param {number} [parameters.revenue] - Sale price if available, otherwise the regular (retail) price of item
       * @param {string} [parameters.itemName] - Product item name
       * @param {string} [parameters.variationId] - Product item variation unique identifier
       * @param {string} [parameters.type='add_to_cart'] - Conversion type
       * @param {boolean} [parameters.isCustomType] - Specify if type is custom conversion type
       * @param {string} [parameters.displayName] - Display name for the custom conversion type
       * @param {string} [parameters.section="Products"] - Index section
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User performed an action indicating interest in an item (add to cart, add to wishlist, etc.)
       * @see https://docs.constructor.com/docs/integrating-with-constructor-behavioral-tracking-data-driven-event-tracking
       * @example
       * constructorio.tracker.trackConversion(
       *     'T-Shirt',
       *     {
       *         itemId: 'KMH876',
       *         revenue: 12.00,
       *         itemName: 'Red T-Shirt',
       *         variationId: 'KMH879-7632',
       *         type: 'like',
       *         section: 'Products',
       *     },
       * );
       */
    }, {
      key: "trackConversion",
      value: function(e, t) {
        var _ = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        if (t && (0, E.default)(t) === "object" && !Array.isArray(t)) {
          var n = e || "TERM_UNKNOWN", c = "".concat(this.options.serviceUrl, "/v2/behavioral_action/conversion?"), S = {}, s = {}, i = t.name, r = t.item_name, u = t.itemName, o = u === void 0 ? r || i : u, y = t.customer_id, k = t.customerId, R = k === void 0 ? y : k, O = t.item_id, N = t.itemId, T = N === void 0 ? O || R : N, U = t.variation_id, D = t.variationId, L = D === void 0 ? U : D, I = t.revenue, B = t.section, P = B === void 0 ? "Products" : B, F = t.display_name, J = t.displayName, M = J === void 0 ? F : J, j = t.type, V = t.is_custom_type, G = t.isCustomType, K = G === void 0 ? V : G;
          T && (s.item_id = T), o && (s.item_name = o), L && (s.variation_id = L), (I || I === 0) && (s.revenue = I.toString()), P && (S.section = P, s.section = P), n && (s.search_term = n), j && (s.type = j), K && (s.is_custom_type = K), M && (s.display_name = M);
          var H = "".concat(c).concat(A(S, this.options)), Y = "POST", z = p(s, d(d({}, this.options), {}, {
            requestMethod: Y
          }));
          return this.requests.queue(H, Y, z, _), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters are required of type object");
      }
      /**
       * Send purchase event to API
       *
       * @function trackPurchase
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {Array.<{itemId: string | undefined,
       * variationId: string | undefined,
       * itemName: string | undefined,
       * count: number | undefined,
       * price: number | undefined}>} parameters.items - List of product item objects
       * @param {number} parameters.revenue - The subtotal (excluding taxes, shipping, etc.) of the entire order
       * @param {string} [parameters.orderId] - Unique order identifier
       * @param {string} [parameters.section="Products"] - Index section
       * @param {object} [parameters.analyticsTags] - Pass additional analytics data
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User completed an order (usually fired on order confirmation page)
       * @example
       * constructorio.tracker.trackPurchase(
       *     {
       *         items: [{ itemId: 'KMH876', price: 1, count: 1}, { itemId: 'KMH140', price: 1, count: 1s }],
       *         revenue: 12.00,
       *         orderId: 'OUNXBG2HMA',
       *         section: 'Products',
       *     },
       * );
       */
    }, {
      key: "trackPurchase",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, E.default)(e) === "object" && !Array.isArray(e)) {
          var _ = "".concat(this.options.serviceUrl, "/v2/behavioral_action/purchase?"), n = {}, c = {}, S = e.items, s = e.revenue, i = e.order_id, r = e.orderId, u = r === void 0 ? i : r, o = e.section, y = e.analyticsTags, k = this.options.apiKey;
          if (u) {
            if (a.hasOrderIdRecord({
              orderId: u,
              apiKey: k
            }))
              return !1;
            a.addOrderIdRecord({
              orderId: u,
              apiKey: k
            }), c.order_id = u;
          }
          S && Array.isArray(S) && (c.items = S.slice(0, 100).map(function(T) {
            return a.toSnakeCaseKeys(T, !1);
          })), (s || s === 0) && (c.revenue = s), o ? n.section = o : n.section = "Products", y && (c.analytics_tags = y);
          var R = "".concat(_).concat(A(n, this.options)), O = "POST", N = p(c, d(d({}, this.options), {}, {
            requestMethod: O
          }));
          return this.requests.queue(R, O, N, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters are required of type object");
      }
      /**
       * Send recommendation view event to API
       *
       * @function trackRecommendationView
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.url - Current page URL
       * @param {string} parameters.podId - Pod identifier
       * @param {number} parameters.numResultsViewed - Number of results viewed
       * @param {object[]} [parameters.items] - List of Product Item Objects
       * @param {number} [parameters.resultCount] - Total number of results
       * @param {number} [parameters.resultPage] - Page number of results
       * @param {string} [parameters.resultId] - Recommendation result identifier (returned in response from Constructor)
       * @param {string} [parameters.section="Products"] - Results section
       * @param {object} [parameters.analyticsTags] - Pass additional analytics data
       * @param {string[]|string|number} [parameters.seedItemIds] - Item ID(s) to be used as seed
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User viewed a set of recommendations
       * @example
       * constructorio.tracker.trackRecommendationView(
       *     {
       *         items: [{ itemId: 'KMH876' }, { itemId: 'KMH140' }],
       *         resultCount: 22,
       *         resultPage: 2,
       *         resultId: '019927c2-f955-4020-8b8d-6b21b93cb5a2',
       *         url: 'https://demo.constructor.io/sandbox/farmstand',
       *         podId: '019927c2-f955-4020',
       *         numResultsViewed: 3,
       *     },
       * );
       */
    }, {
      key: "trackRecommendationView",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, E.default)(e) === "object" && !Array.isArray(e)) {
          var _ = "".concat(this.options.serviceUrl, "/v2/behavioral_action/recommendation_result_view?"), n = {}, c = e.result_count, S = e.result_page, s = e.resultPage, i = s === void 0 ? S : s, r = e.result_id, u = e.resultId, o = u === void 0 ? r : u, y = e.section, k = e.url, R = e.pod_id, O = e.podId, N = O === void 0 ? R : O, T = e.num_results_viewed, U = e.numResultsViewed, D = U === void 0 ? T : U, L = e.items, I = e.analyticsTags, B = e.seedItemIds, P = e.resultCount, F = P === void 0 ? c || (L == null ? void 0 : L.length) || 0 : P;
          a.isNil(F) || (n.result_count = F), a.isNil(i) || (n.result_page = i), o && (n.result_id = o), y ? n.section = y : n.section = "Products", k && (n.url = a.truncateString(k, m)), N && (n.pod_id = N), a.isNil(D) || (n.num_results_viewed = D), L && Array.isArray(L) && (n.items = L.slice(0, 100).map(function(V) {
            return a.toSnakeCaseKeys(V, !1);
          })), I && (n.analytics_tags = I), typeof B == "number" ? n.seed_item_ids = [String(B)] : B != null && B.length && typeof B == "string" ? n.seed_item_ids = [B] : B != null && B.length && Array.isArray(B) && (n.seed_item_ids = B);
          var J = "".concat(_).concat(A({}, this.options)), M = "POST", j = p(n, d(d({}, this.options), {}, {
            requestMethod: M
          }));
          return this.requests.queue(J, M, j, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters are required of type object");
      }
      /**
       * Send media impression view event to API
       *
       * @function trackMediaImpressionView
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.bannerAdId - Banner ad identifier
       * @param {string} parameters.placementId - Placement identifier
       * @param {object} [parameters.analyticsTags] - Pass additional analytics data
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User viewed a media banner
       * @example
       * constructorio.tracker.trackMediaImpressionView(
       *     {
       *         bannerAdId: 'banner_ad_id',
       *         placementId: 'placement_id',
       *     },
       * );
       */
    }, {
      key: "trackMediaImpressionView",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, E.default)(e) === "object" && !Array.isArray(e)) {
          var _ = a.getBehaviorUrl(this.options.mediaServiceUrl), n = "".concat(_.toString(), "v2/ad_behavioral_action/display_ad_view?"), c = {}, S = e.bannerAdId, s = e.placementId, i = e.analyticsTags;
          a.isNil(S) || (c.banner_ad_id = S), a.isNil(s) || (c.placement_id = s), a.isNil(i) || (c.analytics_tags = i);
          var r = "".concat(n).concat(A({}, this.options)), u = "POST", o = p(c, d(d({}, this.options), {}, {
            requestMethod: u
          }));
          return this.requests.queue(r, u, o, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters are required of type object");
      }
      /**
       * Send media impression click event to API
       *
       * @function trackMediaImpressionClick
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.bannerAdId - Banner ad identifier
       * @param {string} parameters.placementId - Placement identifier
       * @param {object} [parameters.analyticsTags] - Pass additional analytics data
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User clicked a media banner
       * @example
       * constructorio.tracker.trackMediaImpressionClick(
       *     {
       *         bannerAdId: 'banner_ad_id',
       *         placementId: 'placement_id',
       *     },
       * );
       */
    }, {
      key: "trackMediaImpressionClick",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, E.default)(e) === "object" && !Array.isArray(e)) {
          var _ = a.getBehaviorUrl(this.options.mediaServiceUrl), n = "".concat(_.toString(), "v2/ad_behavioral_action/display_ad_click?"), c = {}, S = e.bannerAdId, s = e.placementId, i = e.analyticsTags;
          a.isNil(S) || (c.banner_ad_id = S), a.isNil(s) || (c.placement_id = s), a.isNil(i) || (c.analytics_tags = i);
          var r = "".concat(n).concat(A({}, this.options)), u = "POST", o = p(c, d(d({}, this.options), {}, {
            requestMethod: u
          }));
          return this.requests.queue(r, u, o, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters are required of type object");
      }
      /**
       * Send recommendation click event to API
       *
       * @function trackRecommendationClick
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.podId - Pod identifier
       * @param {string} parameters.strategyId - Strategy identifier
       * @param {string} parameters.itemId - Product item unique identifier
       * @param {string} parameters.itemName - Product item name
       * @param {string} [parameters.variationId] - Product item variation unique identifier
       * @param {string} [parameters.section="Products"] - Index section
       * @param {string} [parameters.resultId] - Recommendation result identifier (returned in response from Constructor)
       * @param {number} [parameters.resultCount] - Total number of results
       * @param {number} [parameters.resultPage] - Page number of results
       * @param {number} [parameters.resultPositionOnPage] - Position of result on page
       * @param {number} [parameters.numResultsPerPage] - Number of results on page
       * @param {object} [parameters.analyticsTags] - Pass additional analytics data
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @param {string} [parameters.slCampaignId] - Pass campaign id of sponsored listing
       * @param {string} [parameters.slCampaignOwner] - Pass campaign owner of sponsored listing
       * @param {string[]|string|number} [parameters.seedItemIds] - Item ID(s) to be used as seed
       * @returns {(true|Error)}
       * @description User clicked an item that appeared within a list of recommended results
       * @example
       * constructorio.tracker.trackRecommendationClick(
       *     {
       *         variationId: 'KMH879-7632',
       *         resultId: '019927c2-f955-4020-8b8d-6b21b93cb5a2',
       *         resultCount: 22,
       *         resultPage: 2,
       *         resultPositionOnPage: 2,
       *         numResultsPerPage: 12,
       *         podId: '019927c2-f955-4020',
       *         strategyId: 'complimentary',
       *         itemId: 'KMH876',
       *         itemName: 'Socks',
       *         seedItemIds: ['item-123', 'item-456'],
       *     },
       * );
       */
    }, {
      key: "trackRecommendationClick",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, E.default)(e) === "object" && !Array.isArray(e)) {
          var _ = "".concat(this.options.serviceUrl, "/v2/behavioral_action/recommendation_result_click?"), n = {}, c = e.variation_id, S = e.variationId, s = S === void 0 ? c : S, i = e.section, r = i === void 0 ? "Products" : i, u = e.result_id, o = e.resultId, y = o === void 0 ? u : o, k = e.result_count, R = e.resultCount, O = R === void 0 ? k : R, N = e.result_page, T = e.resultPage, U = T === void 0 ? N : T, D = e.result_position_on_page, L = e.resultPositionOnPage, I = L === void 0 ? D : L, B = e.num_results_per_page, P = e.numResultsPerPage, F = P === void 0 ? B : P, J = e.pod_id, M = e.podId, j = M === void 0 ? J : M, V = e.strategy_id, G = e.strategyId, K = G === void 0 ? V : G, H = e.item_id, Y = e.itemId, z = Y === void 0 ? H : Y, $ = e.item_name, X = e.itemName, Z = X === void 0 ? $ : X, ee = e.analyticsTags, Q = e.slCampaignId, re = e.slCampaignOwner, W = e.seedItemIds;
          s && (n.variation_id = s), r && (n.section = r), y && (n.result_id = y), a.isNil(O) || (n.result_count = O), a.isNil(U) || (n.result_page = U), a.isNil(I) || (n.result_position_on_page = I), a.isNil(F) || (n.num_results_per_page = F), j && (n.pod_id = j), K && (n.strategy_id = K), z && (n.item_id = z), Z && (n.item_name = Z), ee && (n.analytics_tags = ee), Q && (n.sl_campaign_id = Q), re && (n.sl_campaign_owner = re), typeof W == "number" ? n.seed_item_ids = [String(W)] : W != null && W.length && typeof W == "string" ? n.seed_item_ids = [W] : W != null && W.length && Array.isArray(W) && (n.seed_item_ids = W);
          var ue = "".concat(_).concat(A({}, this.options)), ie = "POST", ae = p(n, d(d({}, this.options), {}, {
            requestMethod: ie
          }));
          return this.requests.queue(ue, ie, ae, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters are required of type object");
      }
      /**
       * Send browse results loaded event to API
       *
       * @function trackBrowseResultsLoaded
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.url - Current page URL
       * @param {string} parameters.filterName - Filter name
       * @param {string} parameters.filterValue - Filter value
       * @param {object[]} parameters.items - List of product item objects
       * @param {string} [parameters.section="Products"] - Index section
       * @param {number} [parameters.resultCount] - Total number of results
       * @param {number} [parameters.resultPage] - Page number of results
       * @param {string} [parameters.resultId] - Browse result identifier (returned in response from Constructor)
       * @param {object} [parameters.selectedFilters] - Selected filters
       * @param {string} [parameters.sortOrder] - Sort order ('ascending' or 'descending')
       * @param {string} [parameters.sortBy] - Sorting method
       * @param {object} [parameters.analyticsTags] - Pass additional analytics data
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User viewed a browse product listing page
       * @example
       * constructorio.tracker.trackBrowseResultsLoaded(
       *     {
       *         resultCount: 22,
       *         resultPage: 2,
       *         resultId: '019927c2-f955-4020-8b8d-6b21b93cb5a2',
       *         selectedFilters: { brand: ['foo'], color: ['black'] },
       *         sortOrder: 'ascending',
       *         sortBy: 'price',
       *         items: [{ itemId: 'KMH876' }, { itemId: 'KMH140' }],
       *         url: 'https://demo.constructor.io/sandbox/farmstand',
       *         filterName: 'brand',
       *         filterValue: 'XYZ',
       *     },
       * );
       */
    }, {
      key: "trackBrowseResultsLoaded",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, E.default)(e) === "object" && !Array.isArray(e)) {
          var _, n = "".concat(this.options.serviceUrl, "/v2/behavioral_action/browse_result_load?"), c = {}, S = e.section, s = S === void 0 ? "Products" : S, i = e.result_count, r = e.result_page, u = e.resultPage, o = u === void 0 ? r : u, y = e.result_id, k = e.resultId, R = k === void 0 ? y : k, O = e.selected_filters, N = e.selectedFilters, T = N === void 0 ? O : N, U = e.url, D = e.sort_order, L = e.sortOrder, I = L === void 0 ? D : L, B = e.sort_by, P = e.sortBy, F = P === void 0 ? B : P, J = e.filter_name, M = e.filterName, j = M === void 0 ? J : M, V = e.filter_value, G = e.filterValue, K = G === void 0 ? V : G, H = e.items, Y = e.analyticsTags, z = e.resultCount, $ = z === void 0 ? (_ = i ?? (H == null ? void 0 : H.length)) !== null && _ !== void 0 ? _ : 0 : z;
          s && (c.section = s), a.isNil($) || (c.result_count = $), a.isNil(o) || (c.result_page = o), R && (c.result_id = R), T && (c.selected_filters = T), U && (c.url = a.truncateString(U, m)), I && (c.sort_order = I), F && (c.sort_by = F), j && (c.filter_name = j), K && (c.filter_value = K), H && Array.isArray(H) && (c.items = H.slice(0, 100).map(function(Q) {
            return a.toSnakeCaseKeys(Q, !1);
          })), Y && (c.analytics_tags = Y);
          var X = "".concat(n).concat(A({}, this.options)), Z = "POST", ee = p(c, d(d({}, this.options), {}, {
            requestMethod: Z
          }));
          return this.requests.queue(X, Z, ee, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters are required of type object");
      }
      /**
       * Send browse result click event to API
       *
       * @function trackBrowseResultClick
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.filterName - Filter name
       * @param {string} parameters.filterValue - Filter value
       * @param {string} parameters.itemId - Product item unique identifier
       * @param {string} parameters.itemName - Product item name
       * @param {string} [parameters.section="Products"] - Index section
       * @param {string} [parameters.variationId] - Product item variation unique identifier
       * @param {string} [parameters.resultId] - Browse result identifier (returned in response from Constructor)
       * @param {number} [parameters.resultCount] - Total number of results
       * @param {number} [parameters.resultPage] - Page number of results
       * @param {number} [parameters.resultPositionOnPage] - Position of clicked item
       * @param {number} [parameters.numResultsPerPage] - Number of results shown
       * @param {object} [parameters.selectedFilters] -  Selected filters
       * @param {object} [parameters.analyticsTags] - Pass additional analytics data
       * @param {string} [parameters.slCampaignId] - Pass campaign id of sponsored listing
       * @param {string} [parameters.slCampaignOwner] - Pass campaign owner of sponsored listing
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User clicked a result that appeared within a browse product listing page
       * @example
       * constructorio.tracker.trackBrowseResultClick(
       *     {
       *         variationId: 'KMH879-7632',
       *         resultId: '019927c2-f955-4020-8b8d-6b21b93cb5a2',
       *         resultCount: 22,
       *         resultPage: 2,
       *         resultPositionOnPage: 2,
       *         numResultsPerPage: 12,
       *         selectedFilters: { brand: ['foo'], color: ['black'] },
       *         filterName: 'brand',
       *         filterValue: 'XYZ',
       *         itemId: 'KMH876',
       *         slCampaignId: 'Campaign 123',
       *         slCampaignOwner: 'Store 123',
       *     },
       * );
       */
    }, {
      key: "trackBrowseResultClick",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, E.default)(e) === "object" && !Array.isArray(e)) {
          var _ = "".concat(this.options.serviceUrl, "/v2/behavioral_action/browse_result_click?"), n = {}, c = e.section, S = c === void 0 ? "Products" : c, s = e.variation_id, i = e.variationId, r = i === void 0 ? s : i, u = e.result_id, o = e.resultId, y = o === void 0 ? u : o, k = e.result_count, R = e.resultCount, O = R === void 0 ? k : R, N = e.result_page, T = e.resultPage, U = T === void 0 ? N : T, D = e.result_position_on_page, L = e.resultPositionOnPage, I = L === void 0 ? D : L, B = e.num_results_per_page, P = e.numResultsPerPage, F = P === void 0 ? B : P, J = e.selected_filters, M = e.selectedFilters, j = M === void 0 ? J : M, V = e.filter_name, G = e.filterName, K = G === void 0 ? V : G, H = e.filter_value, Y = e.filterValue, z = Y === void 0 ? H : Y, $ = e.customer_id, X = e.customerId, Z = X === void 0 ? $ : X, ee = e.item_id, Q = e.itemId, re = Q === void 0 ? Z || ee : Q, W = e.item_name, ue = e.name, ie = e.itemName, ae = ie === void 0 ? W || ue : ie, _e = e.analyticsTags, pe = e.slCampaignId, de = e.slCampaignOwner;
          S && (n.section = S), r && (n.variation_id = r), y && (n.result_id = y), a.isNil(O) || (n.result_count = O), a.isNil(U) || (n.result_page = U), a.isNil(I) || (n.result_position_on_page = I), a.isNil(F) || (n.num_results_per_page = F), j && (n.selected_filters = j), K && (n.filter_name = K), z && (n.filter_value = z), re && (n.item_id = re), ae && (n.item_name = ae), _e && (n.analytics_tags = _e), pe && (n.sl_campaign_id = pe), de && (n.sl_campaign_owner = de);
          var be = "".concat(_).concat(A({}, this.options)), fe = "POST", Wt = p(n, d(d({}, this.options), {}, {
            requestMethod: fe
          }));
          return this.requests.queue(be, fe, Wt, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters are required of type object");
      }
      /**
       * Send browse redirect event to API
       * @function trackBrowseRedirect
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.searchTerm - The search query that caused redirect
       * @param {string} parameters.filterName - Filter name of the browse page the user is redirected to. Should be the same value sent in `trackBrowseResultsLoaded`
       * @param {string} parameters.filterValue - Filter value of the browse page the user is redirected to. Should be the same value sent in `trackBrowseResultsLoaded`
       * @param {string} [parameters.userInput] - The text that a user had typed at the moment when submitting search request
       * @param {string} [parameters.redirectToUrl] - URL of the  page to which user is redirected
       * @param {string} [parameters.section="Products"] - Index section
       * @param {object} [parameters.selectedFilters] - Selected filters
       * @param {string} [parameters.sortOrder] - Sort order ('ascending' or 'descending')
       * @param {string} [parameters.sortBy] - Sorting method
       * @param {object} [parameters.analyticsTags] - Pass additional analytics data
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User got redirected to a browse product listing page
       * @example
       * constructorio.tracker.trackBrowseRedirect(
       *     {
       *         searchTerm: "books",
       *         filterName: 'brand',
       *         filterValue: 'XYZ',
       *         redirectToUrl: 'https://demo.constructor.io/books',
       *         selectedFilters: { brand: ['foo'], color: ['black'] },
       *         sortOrder: 'ascending',
       *         sortBy: 'price',
       *     },
       * );
       */
    }, {
      key: "trackBrowseRedirect",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, E.default)(e) === "object" && !Array.isArray(e)) {
          var _ = "".concat(this.options.serviceUrl, "/v2/behavioral_action/browse_redirect?"), n = {}, c = e.searchTerm, S = e.userInput, s = e.section, i = s === void 0 ? "Products" : s, r = e.selectedFilters, u = e.redirectToUrl, o = e.sortOrder, y = e.sortBy, k = e.filterName, R = e.filterValue, O = e.analyticsTags;
          c && (n.search_term = c), S && (n.user_input = S), u && (n.redirect_to_url = u), i && (n.section = i), r && (n.selected_filters = r), o && (n.sort_order = o), y && (n.sort_by = y), k && (n.filter_name = k), R && (n.filter_value = R), O && (n.analytics_tags = O);
          var N = "".concat(_).concat(A({}, this.options)), T = "POST", U = p(n, d(d({}, this.options), {}, {
            requestMethod: T
          }));
          return this.requests.queue(N, T, U, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters are required of type object");
      }
      /**
       * Send generic result click event to API
       *
       * @function trackGenericResultClick
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.itemId - Product item unique identifier
       * @param {string} [parameters.itemName] - Product item name
       * @param {string} [parameters.variationId] - Product item variation unique identifier
       * @param {string} [parameters.section="Products"] - Index section
       * @param {object} [parameters.analyticsTags] - Pass additional analytics data
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User clicked a result that appeared outside of the scope of search / browse / recommendations
       * @example
       * constructorio.tracker.trackGenericResultClick(
       *     {
       *         itemId: 'KMH876',
       *         itemName: 'Red T-Shirt',
       *         variationId: 'KMH879-7632',
       *     },
       * );
       */
    }, {
      key: "trackGenericResultClick",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if ((0, E.default)(e) === "object") {
          var _ = "".concat(this.options.serviceUrl, "/v2/behavioral_action/result_click?"), n = {}, c = e.item_id, S = e.itemId, s = S === void 0 ? c : S, i = e.item_name, r = e.itemName, u = r === void 0 ? i : r, o = e.variation_id, y = e.variationId, k = y === void 0 ? o : y, R = e.section, O = R === void 0 ? "Products" : R, N = e.analyticsTags;
          if (s) {
            n.section = O, n.item_id = s, u && (n.item_name = u), k && (n.variation_id = k), N && (n.analytics_tags = N);
            var T = "".concat(_).concat(A({}, this.options)), U = "POST", D = p(n, d(d({}, this.options), {}, {
              requestMethod: U
            }));
            return this.requests.queue(T, U, D, t), this.requests.send(), !0;
          }
        }
        return this.requests.send(), new Error('A parameters object with an "itemId" property is required.');
      }
      /**
       * Send quiz results loaded event to API
       *
       * @function trackQuizResultsLoaded
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.quizId - Quiz identifier
       * @param {string} parameters.quizVersionId - Quiz version identifier
       * @param {string} parameters.quizSessionId - Quiz session identifier associated with this conversion event
       * @param {string} parameters.url - Current page url
       * @param {object[]} parameters.items - List of product item objects
       * @param {string} [parameters.section='Products'] - Index section
       * @param {number} [parameters.resultCount] - Total number of results
       * @param {number} [parameters.resultPage] - The page of the results
       * @param {string} [parameters.resultId] - Quiz result identifier (returned in response from Constructor)
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User viewed a quiz results page
       * @example
       * constructorio.tracker.trackQuizResultsLoaded(
       *     {
       *         quizId: 'coffee-quiz',
       *         quizVersionId: '1231244',
       *         quizSessionId: '3123',
       *         url: 'www.example.com',
       *         resultCount: 167,
       *         items: [{ itemId: 'KMH876', itemName: 'coffee' }, { itemId: 'KMH140', variationId: '123' }],
       *     },
       * );
       */
      // eslint-disable-next-line complexity
    }, {
      key: "trackQuizResultsLoaded",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, E.default)(e) === "object" && !Array.isArray(e)) {
          var _ = "".concat(this.options.serviceUrl, "/v2/behavioral_action/quiz_result_load?"), n = e.quiz_id, c = e.quizId, S = c === void 0 ? n : c, s = e.quiz_version_id, i = e.quizVersionId, r = i === void 0 ? s : i, u = e.quiz_session_id, o = e.quizSessionId, y = o === void 0 ? u : o, k = e.url, R = e.section, O = R === void 0 ? "Products" : R, N = e.result_count, T = e.resultCount, U = T === void 0 ? N : T, D = e.result_id, L = e.resultId, I = L === void 0 ? D : L, B = e.result_page, P = e.resultPage, F = P === void 0 ? B : P, J = e.items, M = {}, j = {};
          if (J && Array.isArray(J) && (j.items = J.slice(0, 100).map(function(H) {
            return a.toSnakeCaseKeys(H, !1);
          })), typeof S != "string")
            return new Error('"quizId" is a required parameter of type string');
          if (typeof r != "string")
            return new Error('"quizVersionId" is a required parameter of type string');
          if (typeof y != "string")
            return new Error('"quizSessionId" is a required parameter of type string');
          if (typeof k != "string")
            return new Error('"url" is a required parameter of type string');
          if (j.quiz_id = S, j.quiz_version_id = r, j.quiz_session_id = y, j.url = a.truncateString(k, m), !a.isNil(O)) {
            if (typeof O != "string")
              return new Error('"section" must be a string');
            M.section = O, j.section = O;
          }
          if (!a.isNil(U)) {
            if (typeof U != "number")
              return new Error('"resultCount" must be a number');
            j.result_count = U;
          }
          if (!a.isNil(I)) {
            if (typeof I != "string")
              return new Error('"resultId" must be a string');
            j.result_id = I;
          }
          if (!a.isNil(F)) {
            if (typeof F != "number")
              return new Error('"resultPage" must be a number');
            j.result_page = F;
          }
          var V = "".concat(_).concat(A(M, this.options)), G = "POST", K = p(j, d(d({}, this.options), {}, {
            requestMethod: G
          }));
          return this.requests.queue(V, G, K, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters are required of type object");
      }
      /**
       * Send quiz result click event to API
       *
       * @function trackQuizResultClick
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.quizId - Quiz identifier
       * @param {string} parameters.quizVersionId - Quiz version identifier
       * @param {string} parameters.quizSessionId - Quiz session identifier associated with this conversion event
       * @param {string} [parameters.itemId] - Product item unique identifier (Either itemId or itemName is required)
       * @param {string} [parameters.itemName] - Product item name
       * @param {string} [parameters.variationId] - Product variation unique identifier
       * @param {string} [parameters.section='Products'] - Index section
       * @param {number} [parameters.resultCount] - Total number of results
       * @param {number} [parameters.resultPage] - The page of the results
       * @param {string} [parameters.resultId] - Quiz result identifier (returned in response from Constructor)
       * @param {number} [parameters.resultPositionOnPage] - Position of clicked item
       * @param {number} [parameters.numResultsPerPage] - Number of results shown
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User viewed a quiz results page
       * @example
       * constructorio.tracker.trackQuizResultClick(
       *     {
       *         quizId: 'coffee-quiz',
       *         quizVersionId: '1231244',
       *         quizSessionId: '123',
       *         itemId: '123',
       *         itemName: 'espresso'
       *         variationId: '733431',
       *     },
       * );
       */
      // eslint-disable-next-line complexity
    }, {
      key: "trackQuizResultClick",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, E.default)(e) === "object" && !Array.isArray(e)) {
          var _ = "".concat(this.options.serviceUrl, "/v2/behavioral_action/quiz_result_click?"), n = e.quiz_id, c = e.quizId, S = c === void 0 ? n : c, s = e.quiz_version_id, i = e.quizVersionId, r = i === void 0 ? s : i, u = e.quiz_session_id, o = e.quizSessionId, y = o === void 0 ? u : o, k = e.item_id, R = e.itemId, O = R === void 0 ? k : R, N = e.item_name, T = e.itemName, U = T === void 0 ? N : T, D = e.result_count, L = e.resultCount, I = L === void 0 ? D : L, B = e.result_id, P = e.resultId, F = P === void 0 ? B : P, J = e.result_page, M = e.resultPage, j = M === void 0 ? J : M, V = e.num_results_per_page, G = e.numResultsPerPage, K = G === void 0 ? V : G, H = e.result_position_on_page, Y = e.resultPositionOnPage, z = Y === void 0 ? H : Y, $ = e.section, X = $ === void 0 ? "Products" : $, Z = e.variationId, ee = {}, Q = {};
          if (typeof S != "string")
            return new Error('"quizId" is a required parameter of type string');
          if (typeof r != "string")
            return new Error('"quizVersionId" is a required parameter of type string');
          if (typeof y != "string")
            return new Error('"quizSessionId" is a required parameter of type string');
          if (typeof O != "string" && typeof U != "string")
            return new Error('"itemId" or "itemName" is a required parameter of type string');
          if (Q.quiz_id = S, Q.quiz_version_id = r, Q.quiz_session_id = y, !a.isNil(O)) {
            if (typeof O != "string")
              return new Error('"itemId" must be a string');
            Q.item_id = O;
          }
          if (!a.isNil(U)) {
            if (typeof U != "string")
              return new Error('"itemName" must be a string');
            Q.item_name = U;
          }
          if (!a.isNil(Z)) {
            if (typeof Z != "string")
              return new Error('"variationId" must be a string');
            Q.variation_id = Z;
          }
          if (!a.isNil(X)) {
            if (typeof X != "string")
              return new Error('"section" must be a string');
            ee.section = X;
          }
          if (!a.isNil(I)) {
            if (typeof I != "number")
              return new Error('"resultCount" must be a number');
            Q.result_count = I;
          }
          if (!a.isNil(F)) {
            if (typeof F != "string")
              return new Error('"resultId" must be a string');
            Q.result_id = F;
          }
          if (!a.isNil(j)) {
            if (typeof j != "number")
              return new Error('"resultPage" must be a number');
            Q.result_page = j;
          }
          if (!a.isNil(K)) {
            if (typeof K != "number")
              return new Error('"numResultsPerPage" must be a number');
            Q.num_results_per_page = K;
          }
          if (!a.isNil(z)) {
            if (typeof z != "number")
              return new Error('"resultPositionOnPage" must be a number');
            Q.result_position_on_page = z;
          }
          var re = "".concat(_).concat(A(ee, this.options)), W = "POST", ue = p(Q, d(d({}, this.options), {}, {
            requestMethod: W
          }));
          return this.requests.queue(re, W, ue, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters are required of type object");
      }
      /**
       * Send quiz conversion event to API
       *
       * @function trackQuizConversion
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.quizId - Quiz identifier
       * @param {string} parameters.quizVersionId - Quiz version identifier
       * @param {string} parameters.quizSessionId - Quiz session identifier associated with this conversion event
       * @param {string} [parameters.itemId] - Product item unique identifier (Either itemId or itemName is required)
       * @param {string} [parameters.itemName] - Product item name
       * @param {string} [parameters.variationId] - Product item variation unique identifier
       * @param {string} [parameters.revenue] - Sale price if available, otherwise the regular (retail) price of item
       * @param {string} [parameters.section='Products'] - Index section
       * @param {string} [parameters.type='add_to_cart'] - Conversion type
       * @param {boolean} [parameters.isCustomType] - Specify if type is custom conversion type
       * @param {string} [parameters.displayName] - Display name for the custom conversion type
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User viewed a quiz results page
       * @example
       * constructorio.tracker.trackQuizConversion(
       *     {
       *         quizId: 'coffee-quiz',
       *         quizVersionId: '1231244',
       *         quizSessionId: '3123',
       *         itemName: 'espresso',
       *         variationId: '167',
       *         type: 'add_to_cart',
       *         revenue: '1.0'
       *     },
       * );
       */
      // eslint-disable-next-line complexity
    }, {
      key: "trackQuizConversion",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, E.default)(e) === "object" && !Array.isArray(e)) {
          var _ = "".concat(this.options.serviceUrl, "/v2/behavioral_action/quiz_conversion?"), n = e.quiz_id, c = e.quizId, S = c === void 0 ? n : c, s = e.quiz_version_id, i = e.quizVersionId, r = i === void 0 ? s : i, u = e.quiz_session_id, o = e.quizSessionId, y = o === void 0 ? u : o, k = e.item_id, R = e.itemId, O = R === void 0 ? k : R, N = e.item_name, T = e.itemName, U = T === void 0 ? N : T, D = e.variation_id, L = e.variationId, I = L === void 0 ? D : L, B = e.revenue, P = e.section, F = P === void 0 ? "Products" : P, J = e.type, M = e.is_custom_type, j = e.isCustomType, V = j === void 0 ? M : j, G = e.display_name, K = e.displayName, H = K === void 0 ? G : K, Y = {}, z = {};
          if (typeof S != "string")
            return new Error('"quizId" is a required parameter of type string');
          if (typeof r != "string")
            return new Error('"quizVersionId" is a required parameter of type string');
          if (typeof y != "string")
            return new Error('"quizSessionId" is a required parameter of type string');
          if (typeof O != "string" && typeof U != "string")
            return new Error('"itemId" or "itemName" is a required parameter of type string');
          if (z.quiz_id = S, z.quiz_version_id = r, z.quiz_session_id = y, !a.isNil(O)) {
            if (typeof O != "string")
              return new Error('"itemId" must be a string');
            z.item_id = O;
          }
          if (!a.isNil(U)) {
            if (typeof U != "string")
              return new Error('"itemName" must be a string');
            z.item_name = U;
          }
          if (!a.isNil(I)) {
            if (typeof I != "string")
              return new Error('"variationId" must be a string');
            z.variation_id = I;
          }
          if (!a.isNil(B)) {
            if (typeof B != "string")
              return new Error('"revenue" must be a string');
            z.revenue = B;
          }
          if (!a.isNil(F)) {
            if (typeof F != "string")
              return new Error('"section" must be a string');
            z.section = F;
          }
          if (!a.isNil(J)) {
            if (typeof J != "string")
              return new Error('"type" must be a string');
            z.type = J;
          }
          if (!a.isNil(V)) {
            if (typeof V != "boolean")
              return new Error('"isCustomType" must be a boolean');
            z.is_custom_type = V;
          }
          if (!a.isNil(H)) {
            if (typeof H != "string")
              return new Error('"displayName" must be a string');
            z.display_name = H;
          }
          var $ = "".concat(_).concat(A(Y, this.options)), X = "POST", Z = p(z, d(d({}, this.options), {}, {
            requestMethod: X
          }));
          return this.requests.queue($, X, Z, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters are required of type object");
      }
      /**
       * Send ASA request submitted event
       *
       * @function trackAgentSubmit
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.intent - Intent of user request
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User submitted an agent search
       *   (pressing enter within agent input element, or clicking agent submit element)
       * @example
       * constructorio.tracker.trackAgentSubmit(
       *     {
       *         intent: 'show me a recipe for a cookie',
       *     },
       * );
       */
    }, {
      key: "trackAgentSubmit",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, E.default)(e) === "object" && !Array.isArray(e)) {
          var _ = "".concat(this.options.serviceUrl, "/v2/behavioral_action/assistant_submit?"), n = e.section, c = e.intent, S = {
            intent: c,
            section: n
          }, s = "".concat(_).concat(A({}, this.options)), i = "POST", r = p(S, d(d({}, this.options), {}, {
            requestMethod: i
          }));
          return this.requests.queue(s, i, r, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters are required of type object");
      }
      /**
       * Send agent results page load started
       *
       * @function trackAgentResultLoadStarted
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.intent - Intent of user request
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {string} [parameters.intentResultId] - The intent result id from the ASA response
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description Agent results page load begun (but has not necessarily loaded completely)
       * @example
       * constructorio.tracker.trackAgentResultLoadStarted(
       *     {
       *         intent: 'show me a recipe for a cookie',
       *         intentResultId: 'Zde93fd-f955-4020-8b8d-6b21b93cb5a2',
       *     },
       * );
       */
    }, {
      key: "trackAgentResultLoadStarted",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, E.default)(e) === "object" && !Array.isArray(e)) {
          var _ = "".concat(this.options.serviceUrl, "/v2/behavioral_action/assistant_result_load_start?"), n = e.section, c = e.intentResultId, S = e.intent, s = {
            intent_result_id: c,
            intent: S,
            section: n
          }, i = "".concat(_).concat(A({}, this.options)), r = "POST", u = p(s, d(d({}, this.options), {}, {
            requestMethod: r
          }));
          return this.requests.queue(i, r, u, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters are required of type object");
      }
      /**
       * Send agent results page load finished
       *
       * @function trackAgentResultLoadFinished
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.intent - Intent of user request
       * @param {number} parameters.searchResultCount - Number of search results loaded
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {string} [parameters.intentResultId] - The intent result id from the ASA response
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description Agent results page load finished
       * @example
       * constructorio.tracker.trackAgentResultLoadFinished(
       *     {
       *         intent: 'show me a recipe for a cookie',
       *         intentResultId: 'Zde93fd-f955-4020-8b8d-6b21b93cb5a2',
       *         searchResultCount: 5,
       *     },
       * );
       */
    }, {
      key: "trackAgentResultLoadFinished",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, E.default)(e) === "object" && !Array.isArray(e)) {
          var _ = "".concat(this.options.serviceUrl, "/v2/behavioral_action/assistant_result_load_finish?"), n = e.section, c = e.searchResultCount, S = e.intentResultId, s = e.intent, i = {
            intent_result_id: S,
            section: n,
            intent: s,
            search_result_count: c
          }, r = "".concat(_).concat(A({}, this.options)), u = "POST", o = p(i, d(d({}, this.options), {}, {
            requestMethod: u
          }));
          return this.requests.queue(r, u, o, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters are required of type object");
      }
      /**
       * Send agent result click event to API
       *
       * @function trackAgentResultClick
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.intent - intent of the user
       * @param {string} parameters.searchResultId - result_id of the specific search result the clicked item belongs to
       * @param {string} parameters.itemId - Product item unique identifier
       * @param {string} parameters.itemName - Product item name
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {string} [parameters.variationId] - Product item variation unique identifier
       * @param {string} [parameters.intentResultId] - Browse result identifier (returned in response from Constructor)
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User clicked a result that appeared within an agent search result
       * @example
       * constructorio.tracker.trackAgentResultClick(
       *     {
       *         variationId: 'KMH879-7632',
       *         searchResultId: '019927c2-f955-4020-8b8d-6b21b93cb5a2',
       *         intentResultId: 'Zde93fd-f955-4020-8b8d-6b21b93cb5a2',
       *         intent: 'show me a recipe for a cookie',
       *         itemId: 'KMH876',
       *     },
       * );
       */
    }, {
      key: "trackAgentResultClick",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, E.default)(e) === "object" && !Array.isArray(e)) {
          var _ = "".concat(this.options.serviceUrl, "/v2/behavioral_action/assistant_search_result_click?"), n = e.section, c = n === void 0 ? "Products" : n, S = e.variationId, s = e.intentResultId, i = e.searchResultId, r = e.itemId, u = e.itemName, o = e.intent, y = {
            section: c,
            variation_id: S,
            intent_result_id: s,
            search_result_id: i,
            item_id: r,
            item_name: u,
            intent: o
          }, k = "".concat(_).concat(A({}, this.options)), R = "POST", O = p(y, d(d({}, this.options), {}, {
            requestMethod: R
          }));
          return this.requests.queue(k, R, O, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters are required of type object");
      }
      /**
       * Send agent search result view event to API
       *
       * @function trackAgentResultView
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.intent - intent of the user
       * @param {string} parameters.searchResultId - result_id of the specific search result the clicked item belongs to
       * @param {number} parameters.numResultsViewed - Number of items viewed in this search result
       * @param {object[]} [parameters.items] - List of product item objects viewed
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {string} [parameters.intentResultId] - Browse result identifier (returned in response from Constructor)
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User viewed a search result within an agent result
       * @example
       * constructorio.tracker.trackAgentResultView(
       *     {
       *         searchResultId: '019927c2-f955-4020-8b8d-6b21b93cb5a2',
       *         intentResultId: 'Zde93fd-f955-4020-8b8d-6b21b93cb5a2',
       *         intent: 'show me a recipe for a cookie',
       *         numResultsViewed: 5,
       *         items: [{itemId: 'KMH876'}, {itemId: 'KMH140'}, {itemId: 'KMH437'}],
       *     },
       * );
       */
    }, {
      key: "trackAgentResultView",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, E.default)(e) === "object" && !Array.isArray(e)) {
          var _ = "".concat(this.options.serviceUrl, "/v2/behavioral_action/assistant_search_result_view?"), n = e.section, c = n === void 0 ? "Products" : n, S = e.items, s = e.numResultsViewed, i = e.intentResultId, r = e.searchResultId, u = e.intent, o = {
            section: c,
            intent_result_id: i,
            search_result_id: r,
            num_results_viewed: s,
            items: S && Array.isArray(S) && S.slice(0, 100).map(function(O) {
              return a.toSnakeCaseKeys(O, !1);
            }),
            intent: u
          }, y = "".concat(_).concat(A({}, this.options)), k = "POST", R = p(o, d(d({}, this.options), {}, {
            requestMethod: k
          }));
          return this.requests.queue(y, k, R, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters are required of type object");
      }
      /**
       * Send ASA search submitted event
       *
       * @function trackAgentSearchSubmit
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.intent - Intent of user request
       * @param {string} parameters.searchTerm - Term of submitted agent search event
       * @param {string} parameters.searchResultId - resultId of search result the clicked item belongs to
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {string} [parameters.intentResultId] - intentResultId from the ASA response
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User submitted an alternative agent search result search term
       * @example
       * constructorio.tracker.trackAgentSearchSubmit({
       *     {
       *         searchResultId: '019927c2-f955-4020-8b8d-6b21b93cb5a2',
       *         intentResultId: 'Zde93fd-f955-4020-8b8d-6b21b93cb5a2',
       *         intent: 'show me a recipe for a cookie',
       *         searchTerm: 'flour',
       *     },
       * );
       */
    }, {
      key: "trackAgentSearchSubmit",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, E.default)(e) === "object" && !Array.isArray(e)) {
          var _ = "".concat(this.options.serviceUrl, "/v2/behavioral_action/assistant_search_submit?"), n = e.section, c = e.intent, S = e.searchTerm, s = e.searchResultId, i = e.intentResultId, r = {
            intent: c,
            section: n,
            search_term: S,
            search_result_id: s,
            intent_result_id: i
          }, u = "".concat(_).concat(A({}, this.options)), o = "POST", y = p(r, d(d({}, this.options), {}, {
            requestMethod: o
          }));
          return this.requests.queue(u, o, y, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters is a required parameter of type object");
      }
      /**
       * Send ASA request submitted event
       *
       * @deprecated This method will be removed in a future version. Use trackAgentSubmit instead.
       * @function trackAssistantSubmit
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.intent - Intent of user request
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User submitted an assistant search
       *   (pressing enter within assistant input element, or clicking assistant submit element)
       * @example
       * constructorio.tracker.trackAssistantSubmit(
       *     {
       *         intent: 'show me a recipe for a cookie',
       *     },
       * );
       */
    }, {
      key: "trackAssistantSubmit",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return this.trackAgentSubmit(e, t);
      }
      /**
       * Send assistant results page load started
       *
       * @deprecated This method will be removed in a future version. Use trackAgentResultLoadStarted instead.
       * @function trackAssistantResultLoadStarted
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.intent - Intent of user request
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {string} [parameters.intentResultId] - The intent result id from the ASA response
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description Assistant results page load begun (but has not necessarily loaded completely)
       * @example
       * constructorio.tracker.trackAssistantResultLoadStarted(
       *     {
       *         intent: 'show me a recipe for a cookie',
       *         intentResultId: 'Zde93fd-f955-4020-8b8d-6b21b93cb5a2',
       *     },
       * );
       */
    }, {
      key: "trackAssistantResultLoadStarted",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return this.trackAgentResultLoadStarted(e, t);
      }
      /**
       * Send assistant results page load finished
       *
       * @deprecated This method will be removed in a future version. Use trackAgentResultLoadFinished instead.
       * @function trackAssistantResultLoadFinished
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.intent - Intent of user request
       * @param {number} parameters.searchResultCount - Number of search results loaded
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {string} [parameters.intentResultId] - The intent result id from the ASA response
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description Assistant results page load finished
       * @example
       * constructorio.tracker.trackAssistantResultLoadFinished(
       *     {
       *         intent: 'show me a recipe for a cookie',
       *         intentResultId: 'Zde93fd-f955-4020-8b8d-6b21b93cb5a2',
       *         searchResultCount: 5,
       *     },
       * );
       */
    }, {
      key: "trackAssistantResultLoadFinished",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return this.trackAgentResultLoadFinished(e, t);
      }
      /**
       * Send assistant result click event to API
       *
       * @deprecated This method will be removed in a future version. Use trackAgentResultClick instead.
       * @function trackAssistantResultClick
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.intent - intent of the user
       * @param {string} parameters.searchResultId - result_id of the specific search result the clicked item belongs to
       * @param {string} parameters.itemId - Product item unique identifier
       * @param {string} parameters.itemName - Product item name
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {string} [parameters.variationId] - Product item variation unique identifier
       * @param {string} [parameters.intentResultId] - Browse result identifier (returned in response from Constructor)
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User clicked a result that appeared within an assistant search result
       * @example
       * constructorio.tracker.trackAssistantResultClick(
       *     {
       *         variationId: 'KMH879-7632',
       *         searchResultId: '019927c2-f955-4020-8b8d-6b21b93cb5a2',
       *         intentResultId: 'Zde93fd-f955-4020-8b8d-6b21b93cb5a2',
       *         intent: 'show me a recipe for a cookie',
       *         itemId: 'KMH876',
       *     },
       * );
       */
    }, {
      key: "trackAssistantResultClick",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return this.trackAgentResultClick(e, t);
      }
      /**
       * Send assistant search result view event to API
       *
       * @deprecated This method will be removed in a future version. Use trackAgentResultView instead.
       * @function trackAssistantResultView
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.intent - intent of the user
       * @param {string} parameters.searchResultId - result_id of the specific search result the clicked item belongs to
       * @param {number} parameters.numResultsViewed - Number of items viewed in this search result
       * @param {object[]} [parameters.items] - List of product item objects viewed
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {string} [parameters.intentResultId] - Browse result identifier (returned in response from Constructor)
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User viewed a search result within an assistant result
       * @example
       * constructorio.tracker.trackAssistantResultView(
       *     {
       *         searchResultId: '019927c2-f955-4020-8b8d-6b21b93cb5a2',
       *         intentResultId: 'Zde93fd-f955-4020-8b8d-6b21b93cb5a2',
       *         intent: 'show me a recipe for a cookie',
       *         numResultsViewed: 5,
       *         items: [{itemId: 'KMH876'}, {itemId: 'KMH140'}, {itemId: 'KMH437'}],
       *     },
       * );
       */
    }, {
      key: "trackAssistantResultView",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return this.trackAgentResultView(e, t);
      }
      /**
       * Send ASA search submitted event
       *
       * @deprecated This method will be removed in a future version. Use trackAgentSearchSubmit instead.
       * @function trackAssistantSearchSubmit
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.intent - Intent of user request
       * @param {string} parameters.searchTerm - Term of submitted assistant search event
       * @param {string} parameters.searchResultId - resultId of search result the clicked item belongs to
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {string} [parameters.intentResultId] - intentResultId from the ASA response
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User submitted an alternative assistant search result search term
       * @example
       * constructorio.tracker.trackAssistantSearchSubmit({
       *     {
       *         searchResultId: '019927c2-f955-4020-8b8d-6b21b93cb5a2',
       *         intentResultId: 'Zde93fd-f955-4020-8b8d-6b21b93cb5a2',
       *         intent: 'show me a recipe for a cookie',
       *         searchTerm: 'flour',
       *     },
       * );
       */
    }, {
      key: "trackAssistantSearchSubmit",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return this.trackAgentSearchSubmit(e, t);
      }
      /**
       * Send product insights agent view events
       *
       * @function trackProductInsightsAgentViews
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {array.<{question: string}>} parameters.questions - List of pre-defined questions shown to the user
       * @param {string} parameters.itemId - Product id whose page we are on
       * @param {string} parameters.itemName - Product name whose page we are on
       * @param {array.<{start: string | undefined,
       * end: string | undefined}>} parameters.viewTimespans - List of timestamp pairs in ISO_8601 format
       * @param {string} [parameters.variationId] - Variation id whose page we are on
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description The product insights agent element appeared in the visible part of the page
       * @example
       * constructorio.tracker.trackProductInsightsAgentViews({
       *   {
       *     'itemId': '1',
       *     'itemName': 'item1',
       *     'variationId': '2',
       *     'questions': [
       *        { question: 'Why choose this?' },
       *        { question: 'How is this product made?' },
       *        { question: 'What are the dimensions of this product?' }
       *     ],
       *     'viewTimespans': [
       *       {
       *         'start': '2025-05-19T14:30:00+02:00',
       *         'end': '2025-05-19T14:30:05+02:00'
       *       },
       *       {
       *         'start': '2025-05-19T14:30:10+02:00',
       *         'end': '2025-05-19T14:30:15+02:00'
       *       }
       *     ]
       *   },
       * );
       */
    }, {
      key: "trackProductInsightsAgentViews",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, E.default)(e) === "object" && !Array.isArray(e)) {
          var _ = "".concat(this.options.serviceUrl, "/v2/behavioral_action/product_insights_agent_views?"), n = e.section, c = e.questions, S = e.itemId, s = e.itemName, i = e.variationId, r = e.viewTimespans, u = {}, o = {
            questions: c,
            item_id: S,
            item_name: s,
            variation_id: i,
            view_timespans: r
          };
          n && (u.section = n);
          var y = "".concat(_).concat(A(u, this.options)), k = "POST", R = p(o, d(d({}, this.options), {}, {
            requestMethod: k
          }));
          return this.requests.queue(y, k, R, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters is a required parameter of type object");
      }
      /**
       * Send product insights agent view event
       *
       * @function trackProductInsightsAgentView
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {array.<{question: string}>} parameters.questions - List of pre-defined questions shown to the user
       * @param {string} parameters.itemId - Product id whose page we are on
       * @param {string} parameters.itemName - Product name whose page we are on
       * @param {string} [parameters.variationId] - Variation id whose page we are on
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description The product insights agent element appeared in the visible part of the page
       * @example
       * constructorio.tracker.trackProductInsightsAgentView({
       *   {
       *     'itemId': '1',
       *     'itemName': 'item1',
       *     'variationId': '2',
       *     'questions': [
       *        { question: 'Why choose this?' },
       *        { question: 'How is this product made?' },
       *        { question: 'What are the dimensions of this product?' }
       *     ],
       *   },
       * );
       */
    }, {
      key: "trackProductInsightsAgentView",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, E.default)(e) === "object" && !Array.isArray(e)) {
          var _ = "".concat(this.options.serviceUrl, "/v2/behavioral_action/product_insights_agent_view?"), n = e.section, c = e.questions, S = e.itemId, s = e.itemName, i = e.variationId, r = {}, u = {
            questions: c,
            item_id: S,
            item_name: s,
            variation_id: i
          };
          n && (r.section = n);
          var o = "".concat(_).concat(A(r, this.options)), y = "POST", k = p(u, d(d({}, this.options), {}, {
            requestMethod: y
          }));
          return this.requests.queue(o, y, k, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters is a required parameter of type object");
      }
      /**
       * Send product insights agent out of view event
       *
       * @function trackProductInsightsAgentOutOfView
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.itemId - Product id whose page we are on
       * @param {string} parameters.itemName - Product name whose page we are on
       * @param {string} [parameters.variationId] - Variation id whose page we are on
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description The product insights agent element disappeared from the visible part of the page
       * @example
       * constructorio.tracker.trackProductInsightsAgentOutOfView({
       *   {
       *     'itemId': '1',
       *     'itemName': 'item1',
       *     'variationId': '2',
       *   },
       * );
       */
    }, {
      key: "trackProductInsightsAgentOutOfView",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, E.default)(e) === "object" && !Array.isArray(e)) {
          var _ = "".concat(this.options.serviceUrl, "/v2/behavioral_action/product_insights_agent_out_of_view?"), n = e.section, c = e.itemId, S = e.itemName, s = e.variationId, i = {}, r = {
            item_id: c,
            item_name: S,
            variation_id: s
          };
          n && (i.section = n);
          var u = "".concat(_).concat(A(i, this.options)), o = "POST", y = p(r, d(d({}, this.options), {}, {
            requestMethod: o
          }));
          return this.requests.queue(u, o, y, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters is a required parameter of type object");
      }
      /**
       * Send product insights agent input focus event
       *
       * @function trackProductInsightsAgentFocus
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.itemId - Product id whose page we are on
       * @param {string} parameters.itemName - Product name whose page we are on
       * @param {string} [parameters.variationId] - Variation id whose page we are on
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User focused on the product insights agent input element
       * @example
       * constructorio.tracker.trackProductInsightsAgentFocus({
       *   {
       *     'itemId': '1',
       *     'itemName': 'item1',
       *     'variationId': '2',
       *   },
       * );
       */
    }, {
      key: "trackProductInsightsAgentFocus",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, E.default)(e) === "object" && !Array.isArray(e)) {
          var _ = "".concat(this.options.serviceUrl, "/v2/behavioral_action/product_insights_agent_focus?"), n = e.section, c = e.itemId, S = e.itemName, s = e.variationId, i = {}, r = {
            item_id: c,
            item_name: S,
            variation_id: s
          };
          n && (i.section = n);
          var u = "".concat(_).concat(A(i, this.options)), o = "POST", y = p(r, d(d({}, this.options), {}, {
            requestMethod: o
          }));
          return this.requests.queue(u, o, y, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters is a required parameter of type object");
      }
      /**
       * Send product insights agent question click event
       *
       * @function trackProductInsightsAgentQuestionClick
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.itemId - Product id whose page we are on
       * @param {string} parameters.itemName - Product name whose page we are on
       * @param {string} parameters.question - Question a user clicked on
       * @param {string} [parameters.variationId] - Variation id whose page we are on
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User clicked on a question within the product insights agent
       * @example
       * constructorio.tracker.trackProductInsightsAgentQuestionClick({
       *   {
       *     'itemId': '1',
       *     'itemName': 'item1',
       *     'variationId': '2',
       *     'question': 'Why choose this?'
       *   },
       * );
       */
    }, {
      key: "trackProductInsightsAgentQuestionClick",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, E.default)(e) === "object" && !Array.isArray(e)) {
          var _ = "".concat(this.options.serviceUrl, "/v2/behavioral_action/product_insights_agent_question_click?"), n = e.section, c = e.itemId, S = e.itemName, s = e.variationId, i = e.question, r = {}, u = {
            item_id: c,
            item_name: S,
            variation_id: s,
            question: i
          };
          n && (r.section = n);
          var o = "".concat(_).concat(A(r, this.options)), y = "POST", k = p(u, d(d({}, this.options), {}, {
            requestMethod: y
          }));
          return this.requests.queue(o, y, k, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters is a required parameter of type object");
      }
      /**
       * Send product insights agent question submit event
       *
       * @function trackProductInsightsAgentQuestionSubmit
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.itemId - Product id whose page we are on
       * @param {string} parameters.itemName - Product name whose page we are on
       * @param {string} parameters.question - Question a user submitted
       * @param {string} [parameters.variationId] - Variation id whose page we are on
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User submitted a question to the product insights agent
       * @example
       * constructorio.tracker.trackProductInsightsAgentQuestionSubmit({
       *   {
       *     'itemId': '1',
       *     'itemName': 'item1',
       *     'variationId': '2',
       *     'question': 'Tell me some key highlights about this item?'
       *   },
       * );
       */
    }, {
      key: "trackProductInsightsAgentQuestionSubmit",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, E.default)(e) === "object" && !Array.isArray(e)) {
          var _ = "".concat(this.options.serviceUrl, "/v2/behavioral_action/product_insights_agent_question_submit?"), n = e.section, c = e.itemId, S = e.itemName, s = e.variationId, i = e.question, r = {}, u = {
            item_id: c,
            item_name: S,
            variation_id: s,
            question: i
          };
          n && (r.section = n);
          var o = "".concat(_).concat(A(r, this.options)), y = "POST", k = p(u, d(d({}, this.options), {}, {
            requestMethod: y
          }));
          return this.requests.queue(o, y, k, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters is a required parameter of type object");
      }
      /**
       * Send product insights agent answer view event
       *
       * @function trackProductInsightsAgentAnswerView
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.itemId - Product id whose page we are on
       * @param {string} parameters.itemName - Product name whose page we are on
       * @param {string} parameters.question - Question a user submitted
       * @param {string} parameters.answerText - Answer text of the question
       * @param {string} [parameters.qnaResultId] - Answer result id returned
       * @param {string} [parameters.variationId] - Variation id whose page we are on
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User viewed the answer provided by the product insights agent
       * @example
       * constructorio.tracker.trackProductInsightsAgentAnswerView({
       *   {
       *     'itemId': '1',
       *     'itemName': 'item1',
       *     'variationId': '2',
       *     'question': 'Why choose this?',
       *     'answerText': 'This product is awesome!',
       *     'qnaResultId': '0daf0015-fc29-4727-9140-8d5313a1902c',
       *   },
       * );
       */
    }, {
      key: "trackProductInsightsAgentAnswerView",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, E.default)(e) === "object" && !Array.isArray(e)) {
          var _ = "".concat(this.options.serviceUrl, "/v2/behavioral_action/product_insights_agent_answer_view?"), n = e.section, c = e.itemId, S = e.itemName, s = e.variationId, i = e.question, r = e.answerText, u = e.qnaResultId, o = {}, y = {
            item_id: c,
            item_name: S,
            variation_id: s,
            question: i,
            answer_text: r,
            qna_result_id: u
          };
          n && (o.section = n);
          var k = "".concat(_).concat(A(o, this.options)), R = "POST", O = p(y, d(d({}, this.options), {}, {
            requestMethod: R
          }));
          return this.requests.queue(k, R, O, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters is a required parameter of type object");
      }
      /**
       * Send product insights agent answer feedback event
       *
       * @function trackProductInsightsAgentAnswerFeedback
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.itemId - Product id whose page we are on
       * @param {string} parameters.itemName - Product name whose page we are on
       * @param {string} parameters.feedbackLabel - Feedback value: either "thumbs_up" or "thumbs_down"
       * @param {string} [parameters.qnaResultId] - Answer result id returned
       * @param {string} [parameters.variationId] - Variation id whose page we are on
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description A user provided feedback on an answers usefulness
       * @example
       * constructorio.tracker.trackProductInsightsAgentAnswerFeedback({
       *   {
       *     'itemId': '1',
       *     'itemName': 'item1',
       *     'variationId': '2',
       *     'feedbackLabel': 'thumbs_up',
       *     'qnaResultId': '0daf0015-fc29-4727-9140-8d5313a1902c',
       *   },
       * );
       */
    }, {
      key: "trackProductInsightsAgentAnswerFeedback",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, E.default)(e) === "object" && !Array.isArray(e)) {
          var _ = "".concat(this.options.serviceUrl, "/v2/behavioral_action/product_insights_agent_answer_feedback?"), n = e.section, c = e.itemId, S = e.itemName, s = e.variationId, i = e.feedbackLabel, r = e.qnaResultId, u = {}, o = {
            item_id: c,
            item_name: S,
            variation_id: s,
            feedback_label: i,
            qna_result_id: r
          };
          n && (u.section = n);
          var y = "".concat(_).concat(A(u, this.options)), k = "POST", R = p(o, d(d({}, this.options), {}, {
            requestMethod: k
          }));
          return this.requests.queue(y, k, R, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters is a required parameter of type object");
      }
      /**
       * Subscribe to success or error messages emitted by tracking requests
       *
       * @function on
       * @param {string} messageType - Type of message to listen for ('success' or 'error')
       * @param {function} callback - Callback to be invoked when message received
       * @returns {(true|Error)}
       * @example
       * constructorio.tracker.on('error', (data) => {
       *     // Handle tracking error
       * });
       */
    }, {
      key: "on",
      value: function(e, t) {
        return e !== "success" && e !== "error" ? new Error('messageType must be a string of value "success" or "error"') : !t || typeof t != "function" ? new Error("callback is required and must be a function") : (this.eventemitter.on(e, t), !0);
      }
    }]);
  }();
  return C.RequestQueue = w, Fe = C, Fe;
}
var ze = {}, At;
function lr() {
  return At || (At = 1, function(h) {
    Object.defineProperty(h, "__esModule", {
      value: !0
    }), h.default = void 0, h.default = "2.77.1";
  }(ze)), ze;
}
var Me = { exports: {} }, Je = { exports: {} }, Ke = { exports: {} }, Rt;
function Jt() {
  return Rt || (Rt = 1, function(h) {
    function E(x, q) {
      (q == null || q > x.length) && (q = x.length);
      for (var b = 0, g = Array(q); b < q; b++)
        g[b] = x[b];
      return g;
    }
    h.exports = E, h.exports.__esModule = !0, h.exports.default = h.exports;
  }(Ke)), Ke.exports;
}
var Ct;
function fr() {
  return Ct || (Ct = 1, function(h) {
    var E = Jt();
    function x(q) {
      if (Array.isArray(q))
        return E(q);
    }
    h.exports = x, h.exports.__esModule = !0, h.exports.default = h.exports;
  }(Je)), Je.exports;
}
var Ve = { exports: {} }, xt;
function vr() {
  return xt || (xt = 1, function(h) {
    function E(x) {
      if (typeof Symbol < "u" && x[Symbol.iterator] != null || x["@@iterator"] != null)
        return Array.from(x);
    }
    h.exports = E, h.exports.__esModule = !0, h.exports.default = h.exports;
  }(Ve)), Ve.exports;
}
var Ge = { exports: {} }, Ot;
function dr() {
  return Ot || (Ot = 1, function(h) {
    var E = Jt();
    function x(q, b) {
      if (q) {
        if (typeof q == "string")
          return E(q, b);
        var g = {}.toString.call(q).slice(8, -1);
        return g === "Object" && q.constructor && (g = q.constructor.name), g === "Map" || g === "Set" ? Array.from(q) : g === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(g) ? E(q, b) : void 0;
      }
    }
    h.exports = x, h.exports.__esModule = !0, h.exports.default = h.exports;
  }(Ge)), Ge.exports;
}
var He = { exports: {} }, Tt;
function hr() {
  return Tt || (Tt = 1, function(h) {
    function E() {
      throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    h.exports = E, h.exports.__esModule = !0, h.exports.default = h.exports;
  }(He)), He.exports;
}
var Ut;
function gr() {
  return Ut || (Ut = 1, function(h) {
    var E = fr(), x = vr(), q = dr(), b = hr();
    function g(d) {
      return E(d) || x(d) || q(d) || b();
    }
    h.exports = g, h.exports.__esModule = !0, h.exports.default = h.exports;
  }(Me)), Me.exports;
}
var Qe, It;
function _r() {
  if (It)
    return Qe;
  It = 1;
  var h = te, E = h(oe()), x = h(se()), q = h(gr()), b = h(le()), g = ve(), d = ne();
  function f(w, m, p, A) {
    var C = p.apiKey, v = p.clientId, l = p.sessionId, e = p.segments, t = p.userId, _ = p.version, n = p.quizzesServiceUrl, c = {
      c: _
    }, S = "";
    if (c.key = C, c.i = v, c.s = l, e && e.length && (c.us = e), t && (c.ui = String(t)), !w || typeof w != "string")
      throw new Error("quizId is a required parameter of type string");
    if (A === "results" && ((0, b.default)(m.answers) !== "object" || !Array.isArray(m.answers) || m.answers.length === 0))
      throw new Error("answers is a required parameter of type array");
    if (m) {
      var s = m.section, i = m.answers, r = m.quizSessionId, u = m.quizVersionId, o = m.page, y = m.resultsPerPage, k = m.filters, R = m.fmtOptions, O = m.hiddenFields, N = m.skipTracking;
      s && (c.section = s), u && (c.quiz_version_id = u), r && (c.quiz_session_id = r), i && i.length && (S = "&".concat(d.stringify({
        a: i.map(function(U) {
          return (0, q.default)(U.map(encodeURIComponent)).join(",");
        })
      }))), d.isNil(o) || (c.page = o), d.isNil(y) || (c.num_results_per_page = y), k && (c.filters = k), R && (c.fmt_options = R), O && (c.fmt_options ? c.fmt_options.hidden_fields = O : c.fmt_options = {
        hidden_fields: O
      }), N && (c.skip_tracking = N);
    }
    c._dt = Date.now(), c = d.cleanParams(c);
    var T = d.stringify(c);
    return "".concat(n, "/v1/quizzes/").concat(encodeURIComponent(w), "/").concat(encodeURIComponent(A), "/?").concat(T).concat(S);
  }
  var a = /* @__PURE__ */ function() {
    function w(m) {
      (0, E.default)(this, w), this.options = m || {}, this.eventDispatcher = new g(m.eventDispatcher);
    }
    return (0, x.default)(w, [{
      key: "getQuizNextQuestion",
      value: function(p, A) {
        var C = this, v = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, l, e = this.options.fetch, t = new AbortController(), _ = t.signal;
        try {
          l = f(p, A, this.options, "next");
        } catch (n) {
          return Promise.reject(n);
        }
        return d.applyNetworkTimeout(this.options, v, t), e(l, {
          signal: _
        }).then(d.convertResponseToJson).then(function(n) {
          if (n.quiz_version_id)
            return C.eventDispatcher.queue("quizzes.getQuizNextQuestion.completed", n), n;
          throw new Error("getQuizNextQuestion response data is malformed");
        });
      }
      /**
       * Retrieves filter expression and recommendation URL from given answers
       *
       * @function getQuizResults
       * @description Retrieve quiz recommendation and filter expression from Constructor.io API
       * @param {string} quizId - The identifier of the quiz
       * @param {string} parameters - Additional parameters to refine result set
       * @param {array} parameters.answers - An array of answers in the format [[1,2], [1], ["true"], ["seen"], [""]]. Based on the question type, answers should either be an integer, "true"/"false", "seen" or an empty string ("") if skipped
       * @param {string} [parameters.section] - Product catalog section
       * @param {string} [parameters.quizVersionId] - Version identifier for the quiz. Version ID will be returned with the first request and it should be passed with subsequent requests. More information can be found: https://docs.constructor.com/reference/configuration-quizzes
       * @param {string} [parameters.quizSessionId] - Session identifier for the quiz. Session ID will be returned with the first request and it should be passed with subsequent requests. More information can be found: https://docs.constructor.com/reference/configuration-quizzes
       * @param {number} [parameters.page] - The page number of the results
       * @param {number} [parameters.resultsPerPage] - The number of results per page to return
       * @param {object} [parameters.filters] - Key / value mapping (dictionary) of filters used to refine results
       * @param {object} [parameters.fmtOptions] - Key / value mapping (dictionary) of options used for result formatting
       * @param {string[]} [parameters.hiddenFields] - Hidden metadata fields to return
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {Promise}
       * @see https://docs.constructor.com/reference/v1-quizzes-get-quiz-results
       * @example
       * constructorio.quizzes.getQuizResults('quizId', {
       *    answers: [[1,2],[1]],
       *    section: '123',
       *    quizVersionId: '123',
       *    quizSessionId: '234'
       * });
       */
    }, {
      key: "getQuizResults",
      value: function(p, A) {
        var C = this, v = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, l, e = this.options.fetch, t = new AbortController(), _ = t.signal;
        try {
          l = f(p, A, this.options, "results");
        } catch (n) {
          return Promise.reject(n);
        }
        return d.applyNetworkTimeout(this.options, v, t), e(l, {
          signal: _
        }).then(d.convertResponseToJson).then(function(n) {
          if (n.quiz_version_id)
            return C.eventDispatcher.queue("quizzes.getQuizResults.completed", n), n;
          throw new Error("getQuizResults response data is malformed");
        });
      }
      /**
       * Retrieves configuration for the results page of a particular quiz
       *
       * @function getQuizResultsConfig
       * @description Retrieve quiz results page configuration from Constructor.io API
       * @param {string} quizId - The identifier of the quiz
       * @param {string} parameters - Additional parameters
       * @param {string} [parameters.section] - Product catalog section
       * @param {string} [parameters.quizVersionId] - Version identifier for the quiz. Version ID will be returned with the first request and it should be passed with subsequent requests. More information can be found: https://docs.constructor.com/reference/configuration-quizzes
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {Promise}
       * @example
       * constructorio.quizzes.getQuizResultsConfig('quizId', {
       *    quizVersionId: '123',
       * });
       */
    }, {
      key: "getQuizResultsConfig",
      value: function(p, A) {
        var C = this, v = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, l, e = this.options.fetch, t = new AbortController(), _ = t.signal;
        try {
          l = f(p, A, this.options, "results_config");
        } catch (n) {
          return Promise.reject(n);
        }
        return d.applyNetworkTimeout(this.options, v, t), e(l, {
          signal: _
        }).then(d.convertResponseToJson).then(function(n) {
          if (n.quiz_version_id)
            return C.eventDispatcher.queue("quizzes.getQuizResultsConfig.completed", n), n;
          throw new Error("getQuizResultsConfig response data is malformed");
        });
      }
      /**
       * Retrieves all questions for a particular quiz
       *
       * @function getQuizAllQuestions
       * @description Retrieve all questions for a particular quiz from Constructor.io API
       * @param {string} quizId - The identifier of the quiz
       * @param {object} parameters - Additional parameters
       * @param {string} [parameters.section] - Product catalog section
       * @param {string} [parameters.quizVersionId] - Version identifier for the quiz. Version ID will be returned with the first request and it should be passed with subsequent requests. More information can be found: https://docs.constructor.com/reference/configuration-quizzes
       * @param {string} [parameters.quizSessionId] - Session identifier for the quiz. Session ID will be returned with the first request or with getQuizResultsConfig and it should be passed with subsequent requests. More information can be found: https://docs.constructor.com/reference/configuration-quizzes
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {Promise}
       * @example
       * constructorio.quizzes.getQuizAllQuestions('quizId', {
       *    quizVersionId: '123',
       * });
       */
    }, {
      key: "getQuizAllQuestions",
      value: function(p, A) {
        var C = this, v = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, l, e = this.options.fetch, t = new AbortController(), _ = t.signal;
        try {
          l = f(p, A, this.options, "all_questions");
        } catch (n) {
          return Promise.reject(n);
        }
        return d.applyNetworkTimeout(this.options, v, t), e(l, {
          signal: _
        }).then(d.convertResponseToJson).then(function(n) {
          if (n.quiz_version_id)
            return C.eventDispatcher.queue("quizzes.getQuizAllQuestions.completed", n), n;
          throw new Error("getQuizAllQuestions response data is malformed");
        });
      }
    }]);
  }();
  return Qe = a, Qe;
}
var he = { exports: {} }, Nt;
function et() {
  if (Nt)
    return he.exports;
  Nt = 1;
  var h = te, E = h(oe()), x = h(se()), q = h(ke()), b = ne(), g = b.cleanParams, d = b.trimNonBreakingSpaces, f = b.encodeURIComponentRFC3986, a = b.stringify, w = b.isNil;
  function m(C, v, l) {
    var e = l.apiKey, t = l.version, _ = l.sessionId, n = l.clientId, c = l.userId, S = l.segments, s = l.testCells, i = l.agentServiceUrl, r = l.assistantServiceUrl, u = {
      c: t
    };
    u.key = e, u.i = n, u.s = _;
    var o = i || r;
    if (!C || typeof C != "string")
      throw new Error("intent is a required parameter of type string");
    if (!v || !v.domain || typeof v.domain != "string")
      throw new Error("parameters.domain is a required parameter of type string");
    if (s && Object.keys(s).forEach(function(P) {
      u["ef-".concat(P)] = s[P];
    }), S && S.length && (u.us = S), c && (u.ui = String(c)), v) {
      var y = v.domain, k = v.numResultsPerPage, R = v.threadId, O = v.guard, N = v.numResultsPerEvent, T = v.numResultEvents, U = v.qsParam, D = v.preFilterExpression, L = v.fmtOptions;
      y && (u.domain = y), k && (u.num_results_per_page = k), R && (u.thread_id = R), w(O) || (u.guard = O), N && (u.num_results_per_event = N), T && (u.num_result_events = T), U && (u.qs = JSON.stringify(U)), D && (u.pre_filter_expression = JSON.stringify(D)), L && (u.fmt_options = L);
    }
    u._dt = Date.now(), u = g(u);
    var I = a(u), B = C.replace(/^\//, "|");
    return "".concat(o, "/v1/intent/").concat(f(d(B)), "?").concat(I);
  }
  function p(C, v, l) {
    var e = function(_) {
      C.addEventListener(_, function(n) {
        var c = JSON.parse(n.data);
        v.enqueue({
          type: _,
          data: c
        });
      });
    };
    Object.values(l).forEach(function(t) {
      t !== l.END && e(t);
    }), C.addEventListener(l.END, function() {
      v.close(), C.close();
    }), C.onerror = function(t) {
      v.error(t), C.close();
    };
  }
  var A = /* @__PURE__ */ function() {
    function C(v) {
      (0, E.default)(this, C), this.options = v || {};
    }
    return (0, x.default)(C, [{
      key: "getAgentResultsStream",
      value: (
        /**
         * Retrieve agent results from EventStream
         *
         * @function getAgentResultsStream
         * @description Retrieve a stream of agent results from Constructor.io API
         * @param {string} intent - Intent to use to perform an intent based recommendations
         * @param {object} parameters - Additional parameters to refine result set
         * @param {string} parameters.domain - Domain name (e.g. "groceries", "recipes")
         * @param {string} [parameters.threadId] - Conversation thread ID for multi-turn dialogue
         * @param {boolean} [parameters.guard] - Enable content moderation
         * @param {number} [parameters.numResultsPerEvent] - Max products per search_result event
         * @param {number} [parameters.numResultEvents] - Max number of search_result events
         * @param {number} [parameters.numResultsPerPage] - Deprecated: use numResultsPerEvent instead
         * @param {object} [parameters.preFilterExpression] - Faceting expression to scope search results. Please refer to https://docs.constructor.com/reference/configuration-collections
         * @param {object} [parameters.fmtOptions] - The format options used to refine result groups. Please refer to https://docs.constructor.com/reference/v1-asa-retrieve-intent#query-params for details
         * @param {string[]} [parameters.fmtOptions.fields] - Product fields to return
         * @param {string[]} [parameters.fmtOptions.hidden_fields] - Hidden fields to return
         * @param {object} [parameters.qsParam] - Parameters listed above can be serialized into a JSON object and parsed through this parameter. Please refer to https://docs.constructor.com/reference/v1-asa-retrieve-intent#query-params
         * @returns {ReadableStream} Returns a ReadableStream.
         * @example
         * const readableStream = constructorio.agent.getAgentResultsStream('I want to get shoes', {
         *     domain: "nike_sportswear",
         * });
         * const reader = readableStream.getReader();
         * const { value, done } = await reader.read();
         */
        function(l, e) {
          var t, _;
          try {
            var n = m(l, e, this.options);
            t = new EventSource(n), _ = new ReadableStream({
              // To be called on stream start
              start: function(i) {
                p(t, i, C.EventTypes);
              },
              // To be called on stream cancelling
              cancel: function() {
                t.close();
              }
            });
          } catch (s) {
            if (_) {
              var c;
              (c = _) === null || c === void 0 || c.cancel();
            } else {
              var S;
              (S = t) === null || S === void 0 || S.close();
            }
            throw new Error(s.message);
          }
          return _;
        }
      )
    }]);
  }();
  return (0, q.default)(A, "EventTypes", {
    START: "start",
    // Denotes the start of the stream
    GROUP: "group",
    // Represents a semantic grouping of search results, optionally having textual explanation
    SEARCH_RESULT: "search_result",
    // Represents a set of results with metadata (used to show results with search refinements)
    ARTICLE_REFERENCE: "article_reference",
    // Represents a set of content with metadata
    RECIPE_INFO: "recipe_info",
    // Represents recipes' auxiliary information like cooking times & serving sizes
    RECIPE_INSTRUCTIONS: "recipe_instructions",
    // Represents recipe instructions
    SERVER_ERROR: "server_error",
    // Server Error event
    IMAGE_META: "image_meta",
    // This event type is used for enhancing recommendations with media content such as images
    MESSAGE: "message",
    // Represents a textual message from the agent
    FOLLOW_UP_QUESTIONS: "follow_up_questions",
    // Represents follow-up question suggestions
    END: "end"
    // Represents the end of data stream
  }), he.exports = A, he.exports.createAgentUrl = m, he.exports.setupEventListeners = p, he.exports;
}
var ge = { exports: {} }, We = { exports: {} }, Xe = { exports: {} }, Lt;
function pr() {
  return Lt || (Lt = 1, function(h) {
    function E(x) {
      if (x === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return x;
    }
    h.exports = E, h.exports.__esModule = !0, h.exports.default = h.exports;
  }(Xe)), Xe.exports;
}
var Dt;
function yr() {
  return Dt || (Dt = 1, function(h) {
    var E = le().default, x = pr();
    function q(b, g) {
      if (g && (E(g) == "object" || typeof g == "function"))
        return g;
      if (g !== void 0)
        throw new TypeError("Derived constructors may only return object or undefined");
      return x(b);
    }
    h.exports = q, h.exports.__esModule = !0, h.exports.default = h.exports;
  }(We)), We.exports;
}
var Ye = { exports: {} }, Bt;
function wr() {
  return Bt || (Bt = 1, function(h) {
    function E(x) {
      return h.exports = E = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(q) {
        return q.__proto__ || Object.getPrototypeOf(q);
      }, h.exports.__esModule = !0, h.exports.default = h.exports, E(x);
    }
    h.exports = E, h.exports.__esModule = !0, h.exports.default = h.exports;
  }(Ye)), Ye.exports;
}
var Ze = { exports: {} }, $e = { exports: {} }, Pt;
function kr() {
  return Pt || (Pt = 1, function(h) {
    function E(x, q) {
      return h.exports = E = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(b, g) {
        return b.__proto__ = g, b;
      }, h.exports.__esModule = !0, h.exports.default = h.exports, E(x, q);
    }
    h.exports = E, h.exports.__esModule = !0, h.exports.default = h.exports;
  }($e)), $e.exports;
}
var jt;
function br() {
  return jt || (jt = 1, function(h) {
    var E = kr();
    function x(q, b) {
      if (typeof b != "function" && b !== null)
        throw new TypeError("Super expression must either be null or a function");
      q.prototype = Object.create(b && b.prototype, {
        constructor: {
          value: q,
          writable: !0,
          configurable: !0
        }
      }), Object.defineProperty(q, "prototype", {
        writable: !1
      }), b && E(q, b);
    }
    h.exports = x, h.exports.__esModule = !0, h.exports.default = h.exports;
  }(Ze)), Ze.exports;
}
var Ft;
function qr() {
  if (Ft)
    return ge.exports;
  Ft = 1;
  var h = te, E = h(oe()), x = h(se()), q = h(yr()), b = h(wr()), g = h(br()), d = h(ke());
  function f(v, l, e) {
    return l = (0, b.default)(l), (0, q.default)(v, a() ? Reflect.construct(l, e || [], (0, b.default)(v).constructor) : l.apply(v, e));
  }
  function a() {
    try {
      var v = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
    } catch {
    }
    return (a = function() {
      return !!v;
    })();
  }
  var w = et(), m = et(), p = m.createAgentUrl, A = m.setupEventListeners, C = /* @__PURE__ */ function(v) {
    function l() {
      var e;
      (0, E.default)(this, l);
      for (var t = arguments.length, _ = new Array(t), n = 0; n < t; n++)
        _[n] = arguments[n];
      return e = f(this, l, [].concat(_)), (0, d.default)(e, "EventTypes", w.EventTypes), e;
    }
    return (0, g.default)(l, v), (0, x.default)(l, [{
      key: "getAssistantResultsStream",
      value: (
        /**
         * Retrieve assistant results from EventStream
         *
         * @deprecated Use getAssistantResultsStream from the Agent module instead.
         * @function getAssistantResultsStream
         * @description Retrieve a stream of assistant results from Constructor.io API
         * @param {string} intent - Intent to use to perform an intent based recommendations
         * @param {object} [parameters] - Additional parameters to refine result set
         * @param {string} [parameters.domain] - domain name e.g. swimming sports gear, groceries
         * @param {number} [parameters.numResultsPerPage] - The total number of results to return
         * @returns {ReadableStream} Returns a ReadableStream.
         * @example
         * const readableStream = constructorio.assistant.getAssistantResultsStream('I want to get shoes', {
         *     domain: "nike_sportswear",
         * });
         * const reader = readableStream.getReader();
         * const { value, done } = await reader.read();
         */
        function(t, _) {
          return this.getAgentResultsStream(t, _);
        }
      )
    }]);
  }(w);
  return ge.exports = C, ge.exports.createAssistantUrl = p, ge.exports.setupEventListeners = A, ge.exports;
}
var Kt = te, mr = Kt(oe()), Sr = Kt(se()), Er = $t(), Ar = tr(), Rr = rr(), Cr = ir(), xr = nr(), Vt = cr(), Or = ve(), ce = ne(), Tr = lr(), Ur = Tr.default, Ir = _r(), Nr = et(), Lr = qr(), Dr = function() {
  var E = "ciojs-client-", x = [];
  return ce.canUseDOM() || x.push("domless"), typeof process < "u" && typeof process.env < "u" && process.env.BUNDLED && x.push("bundled"), "".concat(E).concat(x.join("-")).concat(x.length ? "-" : "").concat(Ur);
}, nt = /* @__PURE__ */ function() {
  function h() {
    var E = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (0, mr.default)(this, h);
    var x = E.apiKey, q = E.version, b = E.serviceUrl, g = E.quizzesServiceUrl, d = E.agentServiceUrl, f = E.assistantServiceUrl, a = E.mediaServiceUrl, w = E.segments, m = E.testCells, p = E.clientId, A = E.sessionId, C = E.userId, v = E.fetch, l = E.trackingSendDelay, e = E.sendReferrerWithTrackingEvents, t = E.sendTrackingEvents, _ = E.eventDispatcher, n = E.idOptions, c = E.beaconMode, S = E.networkParameters, s = E.humanityCheckLocation;
    if (!x || typeof x != "string")
      throw new Error("API key is a required parameter of type string");
    var i, r, u = typeof ot < "u" && ot.CLIENT_VERSION;
    if (ce.canUseDOM()) {
      var o = new Er(n || {});
      i = o.session_id, r = o.client_id;
    } else {
      if (!A || typeof A != "number")
        throw new Error("sessionId is a required user parameter of type number");
      if (!p || typeof p != "string")
        throw new Error("clientId is a required user parameter of type string");
    }
    var y = b && b.replace(/\/$/, "");
    this.options = {
      apiKey: x,
      version: q || u || Dr(),
      serviceUrl: ce.addHTTPSToString(y) || "https://ac.cnstrc.com",
      quizzesServiceUrl: g && g.replace(/\/$/, "") || "https://quizzes.cnstrc.com",
      agentServiceUrl: d && d.replace(/\/$/, "") || "https://agent.cnstrc.com",
      assistantServiceUrl: f && f.replace(/\/$/, "") || "https://assistant.cnstrc.com",
      mediaServiceUrl: a && a.replace(/\/$/, "") || "https://media-cnstrc.com",
      sessionId: A || i,
      clientId: p || r,
      userId: C,
      segments: w,
      testCells: ce.toValidTestCells(m),
      fetch: v || fetch,
      trackingSendDelay: l,
      sendTrackingEvents: t,
      sendReferrerWithTrackingEvents: e,
      eventDispatcher: _,
      beaconMode: c !== !1,
      // Defaults to 'true',
      networkParameters: S || {},
      humanityCheckLocation: s || "session"
    }, this.search = new Ar(this.options), this.browse = new Rr(this.options), this.autocomplete = new Cr(this.options), this.recommendations = new xr(this.options), this.tracker = new Vt(this.options), this.quizzes = new Ir(this.options), this.agent = new Nr(this.options), this.assistant = new Lr(this.options), new Or(E.eventDispatcher).queue("instantiated", this.options);
  }
  return (0, Sr.default)(h, [{
    key: "setClientOptions",
    value: function(x) {
      if (Object.keys(x).length) {
        var q = x.apiKey, b = x.segments, g = x.testCells, d = x.sessionId, f = x.userId, a = x.sendTrackingEvents;
        q && (this.options.apiKey = q), b && (this.options.segments = b), g && (this.options.testCells = ce.toValidTestCells(g)), typeof a == "boolean" && (this.options.sendTrackingEvents = a, this.tracker.requests.sendTrackingEvents = a), d && !ce.canUseDOM() && (this.options.sessionId = d), "userId" in x && (this.options.userId = f);
      }
    }
  }]);
}();
nt.Tracker = Vt;
ce.canUseDOM() && (window.ConstructorioClient = nt);
var Br = nt;
const Pr = /* @__PURE__ */ Xt(Br), we = window.cnstrc || {}, tt = we.indexKey || "", Gt = we.userId || void 0, Ht = Array.isArray(we.userSegments) ? we.userSegments.filter(Boolean) : [];
let rt = null, Qt = null;
if (tt)
  try {
    rt = new Pr({
      apiKey: tt,
      userId: Gt,
      segments: Ht
    });
  } catch (h) {
    Qt = h, console.error(
      "Failed to initialize Constructor client",
      h
    );
  }
window.theme = window.theme || {};
window.theme.constructorIo = {
  client: rt,
  config: {
    apiKey: tt,
    userId: Gt,
    segments: Ht
  },
  error: Qt,
  isReady: rt !== null
};
